import React, { useRef, useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { increment, decrement } from "../../Redux/Action/Action";
import Slider from "react-slick";
import ContactModal from "../model/ContactModal";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { useUserAuth } from "../../context/AppContext";
import { Link } from "react-router-dom";
// import { MetaTags } from "react-meta-tags";
import DesignBanImg from "../../assets/images/design-ban.png";
import { Helmet } from "react-helmet";

function Design() {
  const { subActive, setSubActive } = useUserAuth();
  const [commonModal, setCommonModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routePath = useLocation();
  const location = useLocation();
  const path = location.pathname;
  const scrollToRef = useRef();
  const accuratePath = routePath.pathname;

  useEffect(() => {
    if (accuratePath === "/design") {
      window.scroll({
        top: 0,
        behavior: "instant",
      });
    }

    if (
      accuratePath === "/design" ||
      accuratePath === "/design/website-design" ||
      accuratePath === "/web-design" ||
      accuratePath === "/design/desktop-design" ||
      accuratePath === "/design/mobile-application-design" ||
      accuratePath === "/design/desktop-design/Marketing-design"
    ) {
      setSubActive(0);
    } else if (
      accuratePath === "/design/web-design/UI-UX" ||
      accuratePath === "/ux-ui-designing" ||
      accuratePath === "/design/desktop-design/logo" ||
      accuratePath === "/design/Mobile-application-design/logo" ||
      accuratePath === "/design/marketing-design/Social-media-pages"
    ) {
      setSubActive(1);
    } else if (
      accuratePath === "/design/web-design/logo" ||
      accuratePath === "/design/desktop-design/mockups" ||
      accuratePath === "/design/Mobile-application-design/infographics" ||
      accuratePath === "/design/marketing-design/Social-media-ads-design"
    ) {
      setSubActive(2);
    } else if (
      accuratePath === "/design/web-design/infographics" ||
      accuratePath === "/design/desktop-design/prototype" ||
      accuratePath === "/design/Mobile-application-design/mockups" ||
      accuratePath === "/design/marketing-design/email-design"
    ) {
      setSubActive(3);
    } else if (
      accuratePath === "/design/web-design/landing-pages" ||
      accuratePath === "/design/Mobile-application-design/prototype" ||
      accuratePath === "/design/marketing-design/sales-funnel-pages"
    ) {
      setSubActive(4);
    } else if (accuratePath === "/design/web-design/mockups") {
      setSubActive(5);
    } else if (accuratePath === "/design/web-design/prototype") {
      setSubActive(6);
    } else if (accuratePath === "/design/web-design/splash-pages") {
      setSubActive(7);
    } else if (accuratePath === "/design/web-design/banner-design") {
      setSubActive(8);
    }
    // eslint-disable-next-line
  }, [accuratePath]);

  useEffect(() => {
    var count = 0;
    var path = routePath.pathname;
    for (var i = 0; i < path.length; i++) {
      if (path[i] === "/") {
        count++;
      }
    }
    if (count > 1) {
      scrollToRef.current.scrollIntoView();
    }
  }, [routePath, subActive]);

  const settings = {
    prevArrow: (
      <button
        type="button"
        className="slick-prev"
        onMouseOver={() => dispatch(increment())}
        onMouseLeave={() => dispatch(decrement())}
      >
        Previous
      </button>
    ),
    nextArrow: (
      <button
        type="button"
        className="slick-next"
        onMouseOver={() => dispatch(increment())}
        onMouseLeave={() => dispatch(decrement())}
      >
        Next
      </button>
    ),
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>


      <main className="inner-page" id="services-design">
        <section className="banner dark">
          <img className="banner-img" src={DesignBanImg} alt="..." />
          <div className="banner-inner container">
            <div className="banner-heading">
              <div className="sap-lg-heading">Design</div>
              <div className="text-para">
                To revolutionize brands, unleash opportunities, and accelerate
                growth, we bring together bold digital creativity and profound
                tech know-how, with our DNA, which is rooted in design thinking,
                and its in-depth comprehension of complicated customer behavior.
              </div>
            </div>
          </div>
        </section>
        <section className="sap-card">
          <div
            className="back-blue-art"
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="194.877"
              height="397.823"
              viewBox="0 0 194.877 397.823"
            >
              <g
                id="Group_67"
                data-name="Group 67"
                transform="translate(-2996.562 -104.677)"
              >
                <rect
                  id="Rectangle_90"
                  data-name="Rectangle 90"
                  width="194.877"
                  height="397.823"
                  rx="97.439"
                  transform="translate(2996.562 104.677)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_93"
                  data-name="Rectangle 93"
                  width="117.351"
                  height="318"
                  rx="58.675"
                  transform="translate(3035.325 144.589)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_94"
                  data-name="Rectangle 94"
                  width="55.803"
                  height="237"
                  rx="27.901"
                  transform="translate(3066.099 185.088)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_95"
                  data-name="Rectangle 95"
                  width="16.199"
                  height="175.098"
                  rx="8.099"
                  transform="translate(3085.901 216.039)"
                  fill="#00224b"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div
            className="back-orange-art"
            data-aos="fade-left"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="252.883"
              height="123.877"
              viewBox="0 0 252.883 123.877"
            >
              <g
                id="Group_68"
                data-name="Group 68"
                transform="translate(-4187.117 -707.061)"
              >
                <rect
                  id="Rectangle_99"
                  data-name="Rectangle 99"
                  width="123.877"
                  height="252.883"
                  rx="61.939"
                  transform="translate(4440 707.061) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_100"
                  data-name="Rectangle 100"
                  width="74.596"
                  height="202.142"
                  rx="37.298"
                  transform="translate(4414.629 731.702) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_101"
                  data-name="Rectangle 101"
                  width="35.472"
                  height="150.653"
                  rx="17.736"
                  transform="translate(4388.885 751.264) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_102"
                  data-name="Rectangle 102"
                  width="10.297"
                  height="111.304"
                  rx="5.148"
                  transform="translate(4369.21 763.851) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div className="sap-card-inner container">
            <div className="sec-heading">
              <div className="sap-caption-head">
                <div className="sap-caption">what our services say</div>
              </div>
              <div ref={scrollToRef} className="sap-lg-heading">
                Our services
                <br />
                that we provide
              </div>
            </div>
            <Slider
              {...settings}
              className="services-slider owl-carousel owl-theme"
            >
              <Link to="/design/website-design">
                <div
                  className={
                    accuratePath === "/design" ||
                      accuratePath === "/design/website-design" ||
                      accuratePath === "/web-design" ||
                      accuratePath === "/design/web-design/UI-UX" ||
                      accuratePath === "/ux-ui-designing" ||
                      accuratePath === "/design/web-design/logo" ||
                      accuratePath === "/design/web-design/infographics" ||
                      accuratePath === "/design/web-design/landing-pages" ||
                      accuratePath === "/design/web-design/mockups" ||
                      accuratePath === "/design/web-design/prototype" ||
                      accuratePath === "/design/web-design/splash-pages" ||
                      accuratePath === "/design/web-design/banner-design"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="299.944"
                      height="300"
                      viewBox="0 0 299.944 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_20"
                        data-name="Group 20"
                        transform="translate(-10032.478 -6503.973)"
                      >
                        <path
                          id="Path_114"
                          data-name="Path 114"
                          d="M10218.123,6710.9a3.187,3.187,0,0,0-2.948,2.852l0,.091a3.164,3.164,0,0,0,2.941,2.943h.034a2.943,2.943,0,0,0-.025-5.886Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_115"
                          data-name="Path 115"
                          d="M10192.965,6710.874q-7.753-.015-15.5-.016-8.921,0-17.841.024c-1.237,0-4.117.3-4.133,2.974,0,2.642,2.86,2.948,4.093,2.956q3.577.03,7.155.025l9.5-.009,9.393,0q3.634,0,7.271-.012c1.289-.007,4.288-.3,4.286-2.912v-.107C10197.123,6711.267,10194.513,6710.88,10192.965,6710.874Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_116"
                          data-name="Path 116"
                          d="M10332.4,6529.567a22.482,22.482,0,0,0-.8-6.744,26.978,26.978,0,0,0-25.63-18.85c-36.077.066-73.914.1-119.075.1q-55.929,0-111.859-.042l-16.493-.009a24.54,24.54,0,0,0-13.456,3.535c-7.6,4.778-11.627,10.866-12.322,18.653a1.655,1.655,0,0,0-.01.22c0,.181.014.363.024.552a7.339,7.339,0,0,1-.309,3.045V6714.4a7.13,7.13,0,0,1,.306,3.029c-.01.152-.02.3-.02.5l.006.154.023.176v.222a14.426,14.426,0,0,0,1.34,6.475c5.2,10.928,14.057,16.5,26.313,16.573,10.4.054,21.807.078,35.895.078q11.389,0,22.781-.013l2.112,0q10.337-.007,20.679-.011h5.58c5.544,0,7.064,1.5,7.075,6.966q.032,8.5.007,17.009c-.01,6.283-1.272,7.581-7.5,7.713-15.283.325-26.607,10.759-28.179,25.964-.3,2.925.33,3.977,2.937,4.738h121.364c2.407-1.081,3.033-2.465,2.571-5.529-1.562-10.349-6.442-17.514-14.917-21.9a27.692,27.692,0,0,0-12.958-3.351q-.65,0-1.311.033c-.183.01-.36.014-.536.014a5.88,5.88,0,0,1-4.375-1.615,6.237,6.237,0,0,1-1.6-4.721c.041-3.466.035-6.977.028-10.371-.006-2.806-.011-5.611.009-8.417.034-4.75,1.636-6.385,6.343-6.477,1.22-.024,2.439-.032,3.659-.032.772,0,2.69.008,2.69.008q1.332.008,2.662.008,11.884,0,23.773.011t23.765.011q16.222,0,32.44-.044c14.614-.046,26.967-12,26.973-26.1C10332.429,6660.843,10332.429,6601.763,10332.4,6529.567Zm-293.977,77.01v-2.34q.006-36.135.033-72.272c.009-12.949,8.914-21.655,22.159-21.664q26.221-.015,52.448-.012l189.9,0c14.533,0,23.208,8.721,23.208,23.327l0,26.7c0,39.448-.009,80.237.077,120.437,0,4.24-1.971,6.3-6.027,6.3-.143,0-.293,0-.442-.006-3.507-.088-7.06-.132-10.559-.132-3.575,0-7.2.046-10.765.139-.117,0-.229,0-.337,0a5.228,5.228,0,0,1-4.367-1.779,6.347,6.347,0,0,1-1.07-4.025c.058-36.871.056-74.371.055-110.637v-21.267c0-5.2-.427-5.624-5.691-5.624q-21.485,0-42.975.008c-4.436,0-5.05.615-5.05,5.063v21.751c0,36.08-.006,73.388.068,110.148a6.48,6.48,0,0,1-1.538,4.849,6.1,6.1,0,0,1-4.476,1.514c-.132,0-.269,0-.4-.006-3.632-.088-7.344-.131-11.349-.131-3.881,0-7.937.04-12.411.125l-.248,0c-3.692,0-5.526-1.853-5.6-5.666-.316-16.831-1.053-36.692-4.107-56.381-.724-4.68-.306-8.7,4.083-13.1,8.14-8.166,9.408-20.6,3.23-31.688-5.58-10.015-11.46-20.073-17.145-29.8l-2.9-4.96a3.867,3.867,0,0,0-3.083-2.2,2.828,2.828,0,0,0-2.343,1.609q-2.66,4.538-5.367,9.051l-.129.216c-5.565,9.329-11.319,18.976-16.242,28.807a25.974,25.974,0,0,0,5.155,29.826,7.26,7.26,0,0,1,2.455,6.736c-3.794,21.786-4.708,43.373-5.1,61.62-.1,3.994-2.007,5.936-5.856,5.936l-.337,0c-3.882-.08-7.881-.12-11.887-.12s-8.1.04-12.183.12l-.266,0a5.417,5.417,0,0,1-4.3-1.617,6.074,6.074,0,0,1-1.209-4.153c.051-17.408.056-35.115.061-52.239v-1.966q0-15.42.021-30.837a9.45,9.45,0,0,0-.953-4.387q-6.334-12.614-12.647-25.246-4.992-9.981-9.994-19.961c-.967-1.935-2.031-2.916-3.163-2.916a2.836,2.836,0,0,0-.522.052,3.483,3.483,0,0,0-2.547,2.182q-11.183,22.379-22.4,44.74l-1.036,2.071a8.2,8.2,0,0,0-.485,3.6q.006,12.819.006,25.638c0,18.348,0,39.145.053,59.106a6.013,6.013,0,0,1-1.441,4.5,5.657,5.657,0,0,1-4.172,1.433l-.311-.005c-3.247-.074-6.643-.111-10.383-.111-3.445,0-7.222.031-11.9.1h-.158a5.146,5.146,0,0,1-3.847-1.321,5.277,5.277,0,0,1-1.323-3.94Q10038.433,6644.177,10038.427,6606.577Zm248.319,41.288v.123c-.025,2.988-.051,6.078.1,9.062a6.176,6.176,0,0,1-1.363,4.717,4.951,4.951,0,0,1-3.75,1.457,10.018,10.018,0,0,1-1.424-.11,6.5,6.5,0,0,0-.9-.057,13.641,13.641,0,0,0-1.606.11,3.076,3.076,0,0,0-2.928,2.945,3.126,3.126,0,0,0,2.967,2.932c.121.012.243.014.414.02l.313.012c6.978.294,8.205,1.592,8.205,8.681,0,7.941-1.3,9.236-9.281,9.236q-3.668,0-7.332-.013h-.653q-3.331-.01-6.66-.013c-4.766,0-8.626.028-12.162.087l-.225,0a5.541,5.541,0,0,1-4.131-1.406,5.805,5.805,0,0,1-1.408-4.36c.069-16.458.063-33.614.056-48.751l0-14.173,0-15.7c.006-15.482.012-31.491-.05-47.227a5.92,5.92,0,0,1,1.395-4.407,5.6,5.6,0,0,1,4.112-1.409l.209,0c4.592.071,9.342.1,14.523.1,4.757,0,9.935-.029,15.84-.09h.162a5.812,5.812,0,0,1,4.534,1.578,5.626,5.626,0,0,1,1.111,4.419,30.375,30.375,0,0,0,0,6.234,5.581,5.581,0,0,1-1.157,4.348,4.789,4.789,0,0,1-3.712,1.472,10.035,10.035,0,0,1-1.1-.066,11.581,11.581,0,0,0-1.3-.07,14.428,14.428,0,0,0-1.859.124,2.913,2.913,0,0,0,.045,5.823,20.664,20.664,0,0,0,2.217.112c.636,0,1.3-.023,2.025-.071.167-.011.325-.017.475-.017a4.249,4.249,0,0,1,3.15,1.2,4.745,4.745,0,0,1,1.208,3.544c-.07,5.161-.07,9.913,0,14.525a4.732,4.732,0,0,1-1.2,3.474,4.341,4.341,0,0,1-3.227,1.219c-.135,0-.276,0-.436-.013-.8-.045-1.463-.066-2.083-.066a19.02,19.02,0,0,0-2.166.111,3.059,3.059,0,0,0-2.822,2.972,3.168,3.168,0,0,0,2.93,2.886,2.1,2.1,0,0,0,.255.016l.348.014c7.117.394,8.368,1.709,8.368,8.791,0,.959-.006,1.917-.011,2.9-.014,2.353-.027,4.787.046,7.157a5.07,5.07,0,0,1-1.226,3.831,4.389,4.389,0,0,1-3.274,1.27c-.224,0-.467-.012-.734-.038-.5-.049-1.043-.075-1.608-.075-.626,0-1.3.032-2.006.093a3.061,3.061,0,0,0-3.086,2.989,3.129,3.129,0,0,0,3.06,2.912c.05.005.1.005.2.008,0,0,.271.008.347.008.355,0,.791-.032,1.267-.068.553-.042,1.125-.084,1.705-.084a5.575,5.575,0,0,1,3.97,1.358c1.965,1.919,1.653,4.6,1.445,6.373a12.56,12.56,0,0,0-.117,1.425C10286.776,6644.136,10286.761,6646.032,10286.746,6647.865Zm-119.181,26.426a5.21,5.21,0,0,1,1.292-3.9,5.11,5.11,0,0,1,3.739-1.358l.166,0c3.215.056,6.4.085,9.468.085,3.2,0,6.39-.032,9.491-.093l.2,0a4.721,4.721,0,0,1,5.154,5.448,53.7,53.7,0,0,0,.146,7.061,5.211,5.211,0,0,1-1.1,4.068,4.918,4.918,0,0,1-3.826,1.442c-.161,0-.328,0-.5-.011-1.156-.044-2.417-.065-3.968-.065-.95,0-1.9.007-2.848.015-.966.008-1.931.015-2.9.015-.94,0-1.883-.006-2.823-.013l-.284,0c-.833,0-1.665-.01-2.5-.01-1.486,0-2.7.017-3.821.054-.145,0-.283.007-.415.007a4.838,4.838,0,0,1-3.741-1.4,5.022,5.022,0,0,1-1.11-3.9C10167.614,6679.035,10167.6,6676.339,10167.565,6674.291Zm.8-16.135c.58-10.644,1.77-21.057,3.379-33.416.553-4.24,3.458-4.7,4.682-4.7a7.512,7.512,0,0,1,1.91.277,18.215,18.215,0,0,0,4.692.572,28.184,28.184,0,0,0,4.42-.377,7.668,7.668,0,0,1,1.225-.111c1.406,0,3.835.543,4.314,4.184,1.7,13.207,2.767,23.916,3.347,33.7a4.67,4.67,0,0,1-1.062,3.6,4.413,4.413,0,0,1-3.312,1.253l-.206,0c-1.34-.028-2.679-.036-4.018-.036-.905,0-1.812,0-2.747.008-.9,0-1.807.007-2.708.007-.821,0-1.642,0-2.462-.01h-.159c-.862,0-1.723-.01-2.584-.01-1.547,0-2.8.018-3.945.057-.105,0-.208,0-.3,0a4.509,4.509,0,0,1-3.369-1.263A4.845,4.845,0,0,1,10168.369,6658.156Zm28.3-48.217a21.447,21.447,0,0,1-13.511,5.019,20.175,20.175,0,0,1-12.646-4.557c-8.067-6.421-10.456-16.961-5.806-25.633,3.514-6.545,7.156-12.824,11.025-19.492q2.452-4.227,4.929-8.535l2.573-4.5,3.052,5.237c.868,1.491,1.632,2.8,2.393,4.124,1.314,2.287,2.645,4.566,4,6.886,3.066,5.258,6.237,10.695,9.177,16.163A20.492,20.492,0,0,1,10196.667,6609.939Zm-77.036,29.1v.643c0,13.643.007,27.751.061,41.621a5.9,5.9,0,0,1-1.424,4.422,4.969,4.969,0,0,1-3.671,1.348c-.277,0-.582-.013-.892-.041-.2-.015-.4-.021-.6-.021-.69,0-1.5.07-2.286.138-.881.077-1.791.156-2.686.156a7,7,0,0,1-4.8-1.506c-2.514-2.239-2.111-5.731-1.787-8.543a22.263,22.263,0,0,0,.2-2.491c-.049-8.11-.042-16.3-.035-24.214l.011-18.621c.008-9.532.017-19.389-.05-29.078a5.527,5.527,0,0,1,1.359-4.133,4.88,4.88,0,0,1,3.614-1.329c.2,0,.418.007.651.023.175.011.356.016.54.016.722,0,1.577-.075,2.415-.149.933-.082,1.9-.166,2.836-.166a7.208,7.208,0,0,1,4.939,1.547c2.532,2.283,2.122,5.867,1.791,8.778a23.415,23.415,0,0,0-.205,2.548Q10119.636,6624.51,10119.631,6639.035Zm-23.88-3.429c0,14.813,0,30.131.074,45.409a6.342,6.342,0,0,1-1.49,4.676,5.165,5.165,0,0,1-3.809,1.394c-.317,0-.664-.016-1.049-.052-.21-.02-.428-.027-.65-.027-.646,0-1.405.063-2.162.128-.792.067-1.689.143-2.546.143a6.858,6.858,0,0,1-4.705-1.484c-2.456-2.207-2.064-5.6-1.748-8.322a21.5,21.5,0,0,0,.2-2.426c-.051-8.093-.042-16.271-.035-24.179l0-8.664q0-4.979.009-9.957v-.178c.012-9.486.025-19.294-.068-28.939a5.928,5.928,0,0,1,1.417-4.4,5.075,5.075,0,0,1,3.7-1.357c.271,0,.563.013.884.038.2.016.4.022.607.022.688,0,1.5-.069,2.281-.136.878-.075,1.787-.153,2.676-.153a7,7,0,0,1,4.83,1.525c2.485,2.251,2.086,5.744,1.766,8.559a23.028,23.028,0,0,0-.2,2.479Q10095.756,6622.652,10095.751,6635.606Zm-15.969-44.292,13.23-26.47h11.445l13.239,26.47Zm138.324,188.786h0c8.96,0,17.521,6.225,19.492,14.171l.921,3.712H10126.5l.694-3.562c1.347-6.947,8.478-13.015,16.586-14.113a22.87,22.87,0,0,1,3.078-.2q17.818-.006,35.628,0T10218.106,6780.1Zm-56.735-34.219a4.578,4.578,0,0,1,5.074-5.225h0c4.99.043,10.168.063,15.827.063q7.879,0,15.755-.048h.142a4.543,4.543,0,0,1,5.078,5.083c-.115,8.468-.11,16.052.015,23.189a5.244,5.244,0,0,1-1.3,3.911,5.152,5.152,0,0,1-3.826,1.326l-.3,0c-2.03-.038-4.263-.056-7.029-.056q-2.18,0-4.356.009t-4.376.01q-2.095,0-4.189-.008t-4.176-.008c-2.789,0-5.045.017-7.114.053h-.193a4.992,4.992,0,0,1-3.763-1.316,5.175,5.175,0,0,1-1.274-3.774C10161.457,6762.281,10161.459,6754.907,10161.371,6745.881Zm164.865-46.815c-.168,2.891-.131,5.9-.095,8.811l0,.177c.015,1.222.029,2.444.029,3.667-.009,14.2-8.786,23.018-22.908,23.018q-57.426.014-114.863.009h-126.794c-14.5-.01-23.159-8.631-23.168-23.061,0-1.323.014-2.647.03-3.985.037-2.86.074-5.819-.1-8.66a5.95,5.95,0,0,1,1.3-4.585c1.471-1.562,3.6-1.562,4.744-1.562h.081c30.041.048,60.285.055,85.907.055h100.946c27.889,0,57.948-.008,88.813-.063,1.148,0,3.29,0,4.771,1.571A6,6,0,0,1,10326.236,6699.066Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Website Design</div>
                </div>
              </Link>

              <Link to="/design/desktop-design">
                <div
                  className={
                    accuratePath === "/design/desktop-design" ||
                      accuratePath === "/design/desktop-design/logo" ||
                      accuratePath === "/design/desktop-design/mockups" ||
                      accuratePath === "/design/desktop-design/prototype"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="300.18"
                      height="300"
                      viewBox="0 0 300.18 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_11"
                        data-name="Group 11"
                        transform="translate(-10477.1 -6503.973)"
                      >
                        <path
                          id="Path_55"
                          data-name="Path 55"
                          d="M10565.61,6803.973c-6.494,0-12.639-6.156-12.645-12.664-.006-7.471,5.376-13.169,12.522-13.255a10.77,10.77,0,0,0,8.732-4.138,36.441,36.441,0,0,0,7.077-12.311c.653-2.029,1.329-4.128.127-5.776-1.107-1.523-2.932-1.64-5.389-1.64q-6.541-.012-13.089-.01l-45.859.007q-12.315,0-24.629-.013c-5.038-.008-8.746-1.207-11.67-3.773a11.2,11.2,0,0,1-3.689-6.834V6549.473c1.866-7.622,5.749-10.6,13.824-10.6l6.775-.008q4.978-.007,9.955-.009c5.976,0,10.849.015,15.337.048h.134c1.364,0,5.5,0,6.692-5.036.77-3.222,2.579-6.253,5.69-9.538,4.424-4.655,9.23-9.617,14.4-14.357,3.07-2.816,6.888-5.7,11.906-5.7l.34,0,.138-.022h.1l.081-.009c.146,0,.293.011.437.021.332.023.617.041.9.041a5.034,5.034,0,0,0,1.9-.335h1.274a4.845,4.845,0,0,0,1.865.338c.263,0,.526-.017.79-.034.188-.013.326-.024.465-.024l.205.007.024.005.288.01h.3c5.806,0,10.172,3.481,14.021,7.243,7.1,6.932,14.545,14.38,24.143,24.148a10.344,10.344,0,0,0,7.821,3.3l.218,0c3.534-.064,7.129-.1,10.69-.1,3.4,0,6.885.029,10.352.088l.249,0a10.344,10.344,0,0,0,7.8-3.3c8.827-8.955,17.73-17.865,26.466-26.483,2.74-2.7,5.283-4.94,8.658-4.94.085,0,.169,0,.256,0,.108,0,.164,0,.216.009l.4.03,3.744,0,1.921,0c2.452,0,4.677,1.066,7,3.355,9.156,9.007,18.624,18.322,27.656,27.765a10.154,10.154,0,0,0,7.866,3.409h.089q6.52-.042,13.037-.034l10.555,0q5.008,0,10.02-.018a13.282,13.282,0,0,1,11.428,5.987,10.587,10.587,0,0,1,1.739,6.491c.015,52.1.026,120.755,0,189.768,0,6.407-3.79,11.1-10.139,12.554a30.375,30.375,0,0,1-6.847.624q-20.461-.012-40.916-.01l-39.992,0c-.334,0-.67,0-1,.008s-.633.009-.947.009c-.221,0-.444,0-.666-.008l-.231,0a4.412,4.412,0,0,0-3.745,1.572,4.634,4.634,0,0,0-.49,4.219,35.722,35.722,0,0,0,9.31,15.716,7.873,7.873,0,0,0,5.76,2.3c.239,0,.481-.009.727-.025s.466-.025.7-.025a12.964,12.964,0,0,1,11.513,8.248c2.027,5.477.518,11-4.138,15.147-1.945,1.73-4.394,2.537-7.706,2.537q-20.681-.021-41.256-.018l-29.286,0q-7.192,0-14.387-.036l-.558,0q-7.479-.028-14.959-.038c-8.626,0-15.677.059-22.192.187Zm121.09-4.961a13.586,13.586,0,0,0,2.321-.165,7.68,7.68,0,0,0,6.534-5.719,7.47,7.47,0,0,0-1.11-6.7,9.315,9.315,0,0,0-7.6-3.361q-15.067-.012-30.131-.01l-29.373,0q-29.452,0-58.913.008c-.225,0-.453,0-.68-.008-.258,0-.511-.008-.763-.008a13.411,13.411,0,0,0-1.485.07,7.9,7.9,0,0,0-.783,15.657,17.317,17.317,0,0,0,3.19.227l59.129,0c19.329,0,57.882-.006,58.313-.006C10685.429,6799,10686.476,6799.012,10686.7,6799.012Zm-94.2-45.905c-2.746,0-4.357,1.406-4.66,4.064a30.854,30.854,0,0,1-2.446,8.7c-.917,2.1-1.978,4.141-3.1,6.305-.51.983-1,1.934-1.5,2.906l-1.748,3.462h96.764l-2.351-3.672c-4.141-6.467-6.46-12.256-7.3-18.219-.223-1.611-1.177-3.533-4.446-3.533q-17.348.012-34.619.016-17.3,0-34.594-.032Zm168.64-5.368c.255,0,.512,0,.768.008.278,0,.559.008.838.008.621,0,1.129-.021,1.6-.067a7.522,7.522,0,0,0,7.267-7.718c.03-.95,0-1.894-.019-2.728a25.128,25.128,0,0,1,.067-3.615,5.491,5.491,0,0,0-1-4.428c-1.214-1.371-3.042-1.555-4.67-1.555-55.753.05-112.028.057-164.535.057l-73.223,0c-.3,0-.6,0-.9.01-.28,0-.557.01-.832.01a10.552,10.552,0,0,1-1.251-.059,2.561,2.561,0,0,1-2.372-2.666,2.528,2.528,0,0,1,2.393-2.62,11.879,11.879,0,0,1,1.331-.06c.268,0,.535,0,.8.008.3.005.6.009.889.009h63.548c52.326,0,113.251.006,174.156.073a4.93,4.93,0,0,0,5.7-5.789c-.063-43.512-.061-87.765-.058-130.561l0-31.271c0-.222,0-.444.006-.667a19.428,19.428,0,0,0-.058-2.248c-.4-4.073-3.281-6.833-7.164-6.867-7.518-.052-15.155-.053-22.541-.054q-6.007,0-11.98-.009a3.746,3.746,0,0,0-4.133,3.313c-.6,3.135-2.674,5.551-4.831,7.694q-9.571,9.535-19.11,19.1c-7.782,7.79-15.829,15.847-23.823,23.787a4.324,4.324,0,0,0-.018,7.043c6,5.908,11.993,11.909,17.792,17.714q5.738,5.741,11.489,11.471a8.984,8.984,0,0,1,2.438,3.959l2.014,6.886c3.841,13.13,8.2,28.013,12.438,42.36,1.171,3.931.688,6.69-1.563,8.947a7.145,7.145,0,0,1-5.332,2.265,13.257,13.257,0,0,1-3.835-.646c-14.534-4.375-30.361-9.031-48.388-14.235a11.1,11.1,0,0,1-4.986-2.933q-5.94-5.991-11.912-11.945c-5.521-5.523-11.233-11.234-16.838-16.933a4.431,4.431,0,0,0-7.273-.033c-13.3,13.465-26.906,27.088-40.067,40.262l-3.786,3.79c-3.51,3.513-7.057,5.294-10.544,5.294-3.464,0-6.977-1.759-10.438-5.229q-13.025-13.062-26.062-26.116c-6.874-6.881-6.853-13.88.063-20.8l8.733-8.741c11.469-11.482,23.33-23.355,35.052-34.964a5.7,5.7,0,0,0,2.075-3.9,5.528,5.528,0,0,0-1.993-3.811c-8.682-8.558-17.439-17.318-25.91-25.79q-7.156-7.161-14.327-14.311c-3.326-3.318-5.318-6.455-6.271-9.869a4.643,4.643,0,0,0-4.956-3.654c-5.856.032-11.653.036-17.45.036h-5.8q-5.805,0-11.614.012c-5.395.011-8.247,2.945-8.247,8.485,0,15.29-.01,55.232-.01,55.232q0,54.492-.038,108.984a5.066,5.066,0,0,0,.922,3.326,4.453,4.453,0,0,0,3.553,1.4l.213,0c2.5-.061,5.238-.09,8.37-.09,2.817,0,5.636.022,8.455.046l.662.005a3.646,3.646,0,0,1,2.64.968,2.317,2.317,0,0,1,.649,1.744c-.049,1.59-1.3,2.6-3.256,2.624-1.377.019-2.758.024-4.139.024l-5.523-.009q-1.408,0-2.814.009h-.095c-.547,0-1.172-.048-1.836-.1-.739-.057-1.5-.115-2.25-.115a6.385,6.385,0,0,0-4.205,1.241c-2.018,1.7-1.7,4.441-1.446,6.64a17.319,17.319,0,0,1,.156,1.963c-.031,3.743.311,6.426,2.108,8.238s4.469,2.172,8.206,2.172h134.173q67.087,0,134.166-.008Zm-220.167-96.572a3.676,3.676,0,0,0-1.427.3,9.54,9.54,0,0,0-5.716,6.916,8.5,8.5,0,0,0,2.294,7.762c5.534,5.587,11.186,11.239,16.65,16.705q5.563,5.563,11.076,11.093a8.491,8.491,0,0,0,5.737,2.671l.191.011.191-.02a8.69,8.69,0,0,0,5.369-2.578l.239-.239c14.061-14.107,30-30.1,45.343-45.423a4.224,4.224,0,0,0,1.443-2.959,4.28,4.28,0,0,0-1.474-2.976c-12.992-12.892-23.548-23.443-33.218-33.2a4.545,4.545,0,0,0-3.119-1.531,4.628,4.628,0,0,0-3.286,1.739l-1.462,1.5c-3.249,3.337-6.595,6.775-10.036,9.944a4.384,4.384,0,0,0,.2,7.437,58.5,58.5,0,0,1,4.281,4.227l.393.415c.859.908,2.054,2.669.391,4.265a2.435,2.435,0,0,1-1.694.713,3.694,3.694,0,0,1-2.449-1.138c-2.194-2.087-3.964-3.86-5.564-5.579a4.016,4.016,0,0,0-2.919-1.486,4.1,4.1,0,0,0-2.878,1.429c-1.485,1.57-3.047,3.116-4.557,4.611-.851.842-1.7,1.684-2.543,2.534-.5.507-1.128,1.032-1.794,1.588-2,1.67-4.068,3.4-4.271,5.892-.229,2.759,2.1,4.639,3.978,6.15a17.889,17.889,0,0,1,1.891,1.663c.17.189.37.387.571.582.116.113.207.2.294.294,1.417,1.54,1.553,2.934.4,4.134a2.409,2.409,0,0,1-1.738.793,3.819,3.819,0,0,1-2.521-1.206c-.868-.834-1.725-1.7-2.58-2.558-.947-.953-1.892-1.9-2.858-2.826l-.034-.051A3.345,3.345,0,0,0,10540.97,6651.167Zm133.339,6.96a12.472,12.472,0,0,0-11.458,17.475,6.82,6.82,0,0,0,4.673,4.171c7.092,2.025,14.415,4.183,22.391,6.6a6.311,6.311,0,0,0,1.841.309c1.785,0,3.127-.981,3.989-2.917a25.844,25.844,0,0,1,13.365-13.326c3.372-1.521,3.05-4.012,2.515-5.754-1.64-5.312-3.187-10.679-4.682-15.869,0,0-1.064-3.688-1.48-5.121-1.464-5.013-4.233-7.057-9.559-7.057a12.3,12.3,0,0,0-12.5,12.89,13.216,13.216,0,0,0,3.546,8.39c.8.943,1.478,2.361.14,3.779a2.376,2.376,0,0,1-1.771.835,3.81,3.81,0,0,1-2.244-.906c-.188-.144-.369-.29-.55-.437a14.361,14.361,0,0,0-1.84-1.327A12.668,12.668,0,0,0,10674.309,6658.127Zm-84.587-85.956q-1.709,1.725-3.434,3.49c-2.8,2.859-5.647,5.764-8.573,8.551a5.382,5.382,0,0,0-2,3.712,5.322,5.322,0,0,0,1.927,3.778c17.227,17.142,34.7,34.619,51.6,51.521,0,0,14.545,14.548,21.614,21.614.121.12.234.249.349.378a6.032,6.032,0,0,0,2.977,2.1l2.209.6.688-2.181a17.958,17.958,0,0,1,12.35-12.357l3.7-1.206-2.749-2.749c-24.462-24.462-48.732-48.724-73.085-73.071l-5.875-5.873Zm23.5-21.758a5.277,5.277,0,0,0-3.756,2.028c-3.584,3.873-6.976,7.265-10.369,10.37a5.018,5.018,0,0,0-1.948,3.535,5.233,5.233,0,0,0,1.977,3.777c15.214,15.138,30.648,30.576,45.572,45.506l11.614,11.616c3.525,3.531,7.048,7.071,10.6,10.647l10.323,10.373,1.213-3.7c2.225-6.779,6.353-10.835,12.992-12.768l3.886-1.131-6.722-6.676c-4.389-4.355-8.619-8.557-12.836-12.768l-11.408-11.4c-15.5-15.482-31.519-31.492-47.4-47.465A5.372,5.372,0,0,0,10613.226,6550.413Zm35.388-6.705a4.782,4.782,0,0,0-3.419,1.789c-3.086,3.326-6.512,6.757-10.179,10.2a4.358,4.358,0,0,0-.08,7.137c9.986,9.862,20.574,20.446,32.369,32.354a4.184,4.184,0,0,0,6.782.075c15.917-16.083,30.14-30.328,43.487-43.551,4-3.95,3.979-8.091-.06-12.308-6.264-6.54-12.789-13.021-19.1-19.289l-.329-.327q-3.831-3.807-7.653-7.624a9.117,9.117,0,0,0-3.637-2.38,7.307,7.307,0,0,0-2.295-.367c-3.171,0-6.213,1.964-8.35,5.388-1.395,2.234-.8,4.256,1.754,6.008a7.08,7.08,0,0,1,.574.421,22.072,22.072,0,0,0,2.591,2.753c.529.5,1.022.969,1.467,1.45,1.345,1.455,1.449,2.945.288,4.088a2.455,2.455,0,0,1-1.735.755,3.6,3.6,0,0,1-2.388-1.106c-1.57-1.48-3.616-3.45-5.534-5.564a3.709,3.709,0,0,0-6.019-.056c-4.667,4.811-8.281,8.425-11.723,11.723a4.3,4.3,0,0,0-1.541,3.119,4.485,4.485,0,0,0,1.693,3.162c1.066.992,2.123,2.062,3.144,3.1.691.7,1.384,1.4,2.086,2.089a3.815,3.815,0,0,1,1.191,2.277,2.627,2.627,0,0,1-1.467,2.346,3.269,3.269,0,0,1-1.4.366,2.145,2.145,0,0,1-1.49-.637c-2.185-1.982-4-3.775-5.534-5.479A4.84,4.84,0,0,0,10648.613,6543.708Zm-53.294-11.484a4.218,4.218,0,0,0-2.98,1.482c-10.766,10.851-21.94,22.028-33.212,33.22a3.869,3.869,0,0,0-.02,6.251c1.931,1.8,3.836,3.731,5.678,5.6l.233.236q1.129,1.143,2.264,2.28c.246.245.5.485.795.763l2.052,1.95,2.006-1.821c.334-.3.657-.59.967-.894l7.523-7.526q12.857-12.863,25.731-25.7a4.537,4.537,0,0,0,1.617-3.227,4.365,4.365,0,0,0-1.565-3.027c-2.575-2.408-5.229-5.052-8.111-8.08A4.172,4.172,0,0,0,10595.319,6532.224Zm-28.807-22.905a16.8,16.8,0,0,0-11.574,4.529l-1.288,1.248c-4.869,4.712-9.875,9.559-14.548,14.614a17.168,17.168,0,0,0,.186,23.5c2.02,2.169,4.145,4.269,6.2,6.3,1.3,1.286,2.6,2.572,3.88,3.878a3.6,3.6,0,0,0,5.705.1c10.012-10.083,20.689-20.769,33.6-33.629a4.207,4.207,0,0,0,1.4-2.923,4.127,4.127,0,0,0-1.418-2.862c-1.462-1.416-2.935-2.89-4.358-4.318-1.963-1.968-3.966-3.976-6.032-5.921a17.129,17.129,0,0,0-11.6-4.52l-.1,0Zm54.865,39.774c3.063,3.281,4.46,4.778,6.574,4.778,2.346,0,3.563-1.8,5.773-5.069l2.52-3.723h-18.611Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Desktop Design</div>
                </div>
              </Link>

              <Link to="/design/mobile-application-design">
                <div
                  className={
                    accuratePath === "/design/mobile-application-design" ||
                      accuratePath === "/design/Mobile-application-design/logo" ||
                      accuratePath ===
                      "/design/Mobile-application-design/infographics" ||
                      accuratePath ===
                      "/design/Mobile-application-design/mockups" ||
                      accuratePath ===
                      "/design/Mobile-application-design/prototype"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="239.359"
                      height="300"
                      viewBox="0 0 239.359 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_21"
                        data-name="Group 21"
                        transform="translate(-10972.289 -6503.973)"
                      >
                        <path
                          id="Path_117"
                          data-name="Path 117"
                          d="M11211.639,6681.091l-.006-5.189c-.012-12.671-7.642-20.238-20.408-20.241l-72.043,0c-2.307,0-4.484,0-4.88.368-.361.335-.417,2.373-.476,4.531l-.011.38a5.333,5.333,0,0,0,.077,1.365h0a3.351,3.351,0,0,0,1.437.16c12.248-.057,25.326-.082,42.4-.082q10.866,0,21.732.009l12.341.006c8.18,0,13.074,4.845,13.095,12.952.006,2.849-.025,5.742-.056,8.539-.064,5.886-.131,11.974.158,17.918.217,4.483-.993,8.242-3.5,10.872-2.349,2.466-5.759,3.77-9.858,3.77-.538,0-1.1-.023-1.658-.066-1.236-.1-3.809-.3-3.67-3.843.095-2.42.074-4.905.056-7.309-.008-1.017-.017-2.033-.017-3.054,0-2.888,0-4.974-.416-5.66-.209-.346-1.156-.494-3.169-.494-.746,0-1.6.018-2.581.039l-.155,0c-.2,0-.348.014-.453.026,0,.081,0,.186,0,.319.091,2.571.072,5.171.054,7.686-.007,1.038-.015,2.077-.015,3.115,0,8.292-.741,9.064-8.8,9.179l-.485,0a3.716,3.716,0,0,1-4.265-4.544c.037-.632.124-1.3.208-1.952.145-1.124.415-3.217-.027-3.6-.063-.054-.348-.23-1.391-.23-.491,0-1.031.036-1.6.074-.62.041-1.261.083-1.9.083a10.71,10.71,0,0,1-1.156-.057,4.937,4.937,0,0,0-.541-.034,2.031,2.031,0,0,0-.3.019,3.988,3.988,0,0,0-.033.99c.028.52.105,1.12.187,1.756.31,2.4.66,5.127-1.251,6.587a6,6,0,0,1-3.724,1c-.628,0-1.273-.042-1.9-.082s-1.191-.077-1.74-.077c-.272,0-.538.009-.795.034-.272.027-.523.04-.753.04a3.392,3.392,0,0,1-2.574-.941,4.313,4.313,0,0,1-.936-3.27c.022-.752.121-1.548.217-2.318.139-1.115.4-3.19-.056-3.573-.091-.078-.42-.259-1.491-.259-.528,0-1.111.041-1.729.084-.667.046-1.357.1-2.04.1-.376,0-.744-.015-1.1-.05-.15-.015-.288-.024-.414-.024l-.1,0a5.62,5.62,0,0,0-.022.757c.015.6.1,1.3.194,2.047.295,2.384.631,5.087-1.3,6.546a6.3,6.3,0,0,1-3.829,1.022c-.684,0-1.388-.048-2.069-.1s-1.3-.09-1.9-.09c-.24,0-.477.007-.706.026-.192.015-.373.022-.541.022a3.266,3.266,0,0,1-2.446-.9,3.941,3.941,0,0,1-.875-3c.069-2.441.056-4.94.042-7.357-.006-1.007-.012-2.013-.012-3.027,0-2.856,0-4.92-.408-5.61-.2-.338-1.139-.488-3.045-.488-.781,0-1.686.022-2.729.047l-.21,0c-.157,0-.278.013-.369.023,0,.1-.008.24,0,.428.064,2.805.052,5.647.041,8.4q-.007,1.666-.01,3.333c0,7.192-.731,7.953-7.823,8.15,0,0-.727.019-.9.019a4.956,4.956,0,0,1-3.758-1.208,5.329,5.329,0,0,1-1.1-4.02c.07-1.754.169-4.157-.191-4.541-.335-.358-2.508-.413-4.609-.466,0,0-.6-.014-.712-.014a4.881,4.881,0,0,0-1.088.088l0,0a3.048,3.048,0,0,0-.125,1.338c.116,3.644.187,5.844-1.187,7.285-1.354,1.422-3.351,1.456-7.326,1.523l-.573.008a4.5,4.5,0,0,1-3.375-1.066,4.728,4.728,0,0,1-1.022-3.512c.049-2.216.1-4.728-.336-5.179-.423-.435-2.657-.447-5.244-.46h-.273a4.689,4.689,0,0,0-.851.055,3.6,3.6,0,0,0-.028.731c.021.568.107,1.225.2,1.922.3,2.269.665,5.093-1.3,6.663a5.757,5.757,0,0,1-3.631,1.014c-.7,0-1.429-.057-2.133-.112-.684-.054-1.331-.1-1.931-.1-.192,0-.381.006-.564.019-.208.015-.4.022-.586.022a3.562,3.562,0,0,1-2.629-.954,4.029,4.029,0,0,1-.884-3.045c.1-2.4.08-4.88.059-7.272-.009-1.027-.018-2.053-.018-3.087,0-2.81,0-4.84-.392-5.566-.13-.239-.549-.483-2.675-.483-.884,0-1.976.04-3.24.086l-.138,0c-.134,0-.243.012-.328.019,0,.049,0,.1,0,.166.08,2.653.064,5.337.049,7.933-.006,1.058-.013,2.117-.013,3.175,0,8.119-.722,8.878-8.593,9.031l-.6.009a4.441,4.441,0,0,1-3.339-1.07,4.749,4.749,0,0,1-1.025-3.56c.046-2.308.093-4.694-.34-5.138s-2.661-.447-5.253-.464l-.311,0a4.091,4.091,0,0,0-.81.059,3.568,3.568,0,0,0-.007.737c.03.489.089,1.015.146,1.551.252,2.349.538,5.01-.89,6.673a4.686,4.686,0,0,1-3.658,1.423,19.879,19.879,0,0,1-2.135-.157,17.5,17.5,0,0,0-1.865-.143,4.987,4.987,0,0,0-.617.034,7.219,7.219,0,0,1-.935.066,3.448,3.448,0,0,1-2.627-1,4.494,4.494,0,0,1-.9-3.422c.033-.542.094-1.124.157-1.719.139-1.322.374-3.536-.095-4.076a1.738,1.738,0,0,0-1.1-.245,17.2,17.2,0,0,0-1.764.137,20.7,20.7,0,0,1-2.235.162,8.111,8.111,0,0,1-1.056-.064,3.9,3.9,0,0,0-.488-.036l-.1,0a5.06,5.06,0,0,0-.061.939c.019,4.234.029,6.566-1.445,8.048-1.122,1.127-2.7,1.353-4.884,1.353-.97,0-2.133-.047-3.479-.1l-.158-.006c-2.456-.1-3.569-1.283-3.5-3.725.066-2.524.052-5.1.04-7.6q-.009-1.548-.011-3.095c0-2.67,0-4.976-.443-5.434-.426-.441-2.652-.457-5.228-.475l-.347,0a3.687,3.687,0,0,0-.726.055,4.763,4.763,0,0,0-.035.864c.129,5.19.071,10.452.014,15.532a2.375,2.375,0,0,0,.038.281,3.111,3.111,0,0,1-.427,2.475,2.915,2.915,0,0,1-2.077,1.074,22.394,22.394,0,0,1-2.656.164c-4.145,0-7.6-1.279-10-3.7a12.565,12.565,0,0,1-3.423-9.217c.062-5.833.048-11.77.036-17.512-.007-3.637-.015-7.273,0-10.91.021-7.834,4.867-12.721,12.647-12.754q4.257-.016,8.516-.015l13.293.008c2.748,0,5.121,0,5.6-.463.456-.444.456-2.731.456-5.38v-.28a3.929,3.929,0,0,0-.038-.622,5.448,5.448,0,0,0-.636-.028h-.133q-5.467.052-10.932.044l-10.1-.007q-3.073,0-6.146.011c-11.281.047-19.2,7.936-19.252,19.182-.032,7.045-.023,14.211-.015,21.14l.008,6.655c.007,12.975,7.5,20.418,20.547,20.419l155.983.008q21.7,0,43.4-.016c11.554-.01,19.347-7.789,19.395-19.358C11211.658,6696.164,11211.648,6688.5,11211.639,6681.091Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_118"
                          data-name="Path 118"
                          d="M11008.064,6641.747c.337.361,2.379.42,4.541.482,0,0,.62.017.722.017a4.246,4.246,0,0,0,1.014-.09h0a3.555,3.555,0,0,0,.155-1.461c-.056-14.894-.062-30.035-.07-44.678q-.009-20.153-.054-40.305a3.893,3.893,0,0,1,4.588-4.615h0c13.568.062,27.184.07,37.53.07l30.391-.008h63.822c2.31,0,4.492,0,4.888-.368.361-.336.417-2.374.476-4.532l.01-.37a5.5,5.5,0,0,0-.076-1.37,3.27,3.27,0,0,0-1.429-.163c-21.62.049-45.1.073-71.783.073q-29.036,0-58.083-.027a21.876,21.876,0,0,0-2.392.193,25.39,25.39,0,0,1-2.821.217,5.556,5.556,0,0,1-4.167-1.5c-1.489-1.629-1.258-4.209-1.036-6.7.075-.843.146-1.639.146-2.34,0-14.524,9.015-23.547,23.522-23.551q26.051-.006,52.1,0l55.641,0c14.9,0,23.8,8.943,23.8,23.915,0,24.362,0,102.359,0,102.359,0,2.266,0,4.406.365,4.778s2.488.409,4.741.451l.532.007a.889.889,0,0,0,1.164-1.3c-.07-24.689-.069-49.79-.068-74.064q0-16.36,0-32.721c-.01-18.032-12.181-30.152-30.283-30.158q-25.916-.009-51.824-.009-27.952,0-55.914.008c-18.531,0-30.508,12-30.513,30.563q-.007,35.6,0,71.194V6636.9C11007.7,6639.192,11007.7,6641.356,11008.064,6641.747Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_119"
                          data-name="Path 119"
                          d="M11143.72,6584.613c-3.721-3.747-7.57-7.622-11.4-11.368a13.421,13.421,0,0,0-20.1.122q-23.136,23.091-46.249,46.214-15.535,15.531-31.067,31.053a7.727,7.727,0,0,0-2.135,3.791q-2.568,10.418-5.2,20.82-2.225,8.847-4.43,17.7a4.184,4.184,0,0,0,.5,3.624,3.194,3.194,0,0,0,2.632,1.135,5.864,5.864,0,0,0,1.4-.181q10.118-2.5,20.225-5.052,9.136-2.294,18.28-4.57a7.185,7.185,0,0,0,3.582-1.876q17.574-17.58,35.158-35.152,21.41-21.4,42.813-42.811a13.033,13.033,0,0,0,4.035-9.593,13.238,13.238,0,0,0-4.265-10.059Q11145.606,6586.513,11143.72,6584.613Zm-97.155,63.67a22.535,22.535,0,0,0,1.884-1.6q9.053-9.083,18.126-18.143c10.515-10.514,21.386-21.386,32.026-32.128a5.337,5.337,0,0,1,3.6-1.959,4.655,4.655,0,0,1,3.5,2.139,28.331,28.331,0,0,0,2.8,2.9c.506.477,1.011.954,1.5,1.441.257.257.5.528.772.844.135.154.279.32.444.5l1.023,1.134-1.025,1.132-.458.513c-.3.343-.584.661-.892.975l-13.259,13.255c-13.872,13.866-28.217,28.2-42.291,42.338a4.141,4.141,0,0,1-2.835,1.473,3.851,3.851,0,0,1-2.838-1.587,21.63,21.63,0,0,0-2.115-1.983c-1.792-1.544-3.646-3.141-3.931-5.328C11042.27,6651.7,11044.551,6649.884,11046.564,6648.283Zm-7.757,39.52-5.753-6.764q1.813-7.252,3.524-14.1l1.414-5.659,2.109,2.11c5.56,5.559,11.135,11.142,16.829,16.846l2.443,2.446Zm83.486-63.627a21.294,21.294,0,0,0-1.776,1.508q-20.692,20.755-41.432,41.455l-9,9c-.464.463-.939.91-1.383,1.327l-.563.532-.525.469h-.678a3.337,3.337,0,0,1-2.656-1.357c-.055-.063-.105-.127-.152-.173-.637-.615-1.254-1.252-1.871-1.89-1.006-1.04-1.956-2.023-2.992-2.9a4.037,4.037,0,0,1-1.687-2.845,4.232,4.232,0,0,1,1.59-3.087c5.125-5.022,10.282-10.193,15.27-15.193q3.089-3.1,6.183-6.19l7.981-7.975c8.288-8.278,16.858-16.837,25.233-25.308a5.255,5.255,0,0,1,3.553-1.978,4.5,4.5,0,0,1,3.329,2.028,13.087,13.087,0,0,0,2.069,1.911c1.633,1.316,3.483,2.808,3.476,5.072C11126.257,6621.039,11124.151,6622.705,11122.294,6624.176Zm20.408-20.668c-1.117,1.159-2.276,2.3-3.4,3.41-1.374,1.357-2.795,2.76-4.133,4.186a3.286,3.286,0,0,1-5.416.085c-6.66-6.778-13.475-13.591-20.254-20.254a3.9,3.9,0,0,1-1.41-2.758,3.8,3.8,0,0,1,1.451-2.661c2-1.868,3.966-3.863,5.865-5.792q.954-.969,1.916-1.938a6.622,6.622,0,0,1,4.773-2.123c.133,0,.267,0,.4.012l.161,0a6.807,6.807,0,0,1,4.853,2.309q2.7,2.709,5.411,5.408c3.2,3.191,6.508,6.49,9.733,9.77C11145.912,6596.467,11145.929,6600.142,11142.7,6603.508Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_120"
                          data-name="Path 120"
                          d="M11176.208,6736.609h0a2.607,2.607,0,0,0-1.1-.126c-.109,0-.705.014-.705.014-2.175.059-4.23.114-4.577.482-.386.408-.31,2.861-.248,4.831a4.954,4.954,0,0,1-1.052,3.759,5.2,5.2,0,0,1-3.934,1.158h0c-29.025-.056-57.514-.063-83.978-.063l-47.169,0c-2.5,0-4.665,0-5.087.4-.4.384-.449,2.468-.5,4.882l-.01.4a3.891,3.891,0,0,0,.072,1.022,5.484,5.484,0,0,0,1.221.083h0c13.586-.05,26.791-.056,37.917-.056l59.687.012c11.138,0,24.359-.006,37.972-.052h.085a4.95,4.95,0,0,1,3.777,1.143,4.714,4.714,0,0,1,1,3.6c-.166,3.6-.133,7.295-.1,10.868.017,1.724.031,3.448.026,5.172-.044,13.8-9.307,23.081-23.052,23.088q-27.394.013-54.787.014-27.122,0-54.244-.015c-13.722-.008-22.958-9.312-22.983-23.152q-.021-10.981-.007-21.964l0-9.639c0-2.7,0-5.026-.446-5.493-.424-.44-2.644-.454-5.212-.47h-.3a4.163,4.163,0,0,0-.772.053,4.111,4.111,0,0,0-.052.827c.065,7.892.06,15.912.053,23.669q0,6.5,0,13c.035,17.6,12.342,29.893,29.927,29.906q27.387.019,54.772.019,26.966,0,53.938-.02c17.563-.013,29.856-12.324,29.895-29.938q.013-5.966-.006-11.932c-.015-7.9-.029-16.071.086-24.111A4.9,4.9,0,0,0,11176.208,6736.609Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_121"
                          data-name="Path 121"
                          d="M11092.038,6788.782a13.443,13.443,0,0,0,9.5-22.914,13.338,13.338,0,0,0-9.531-4.015,13.464,13.464,0,0,0-.113,26.928Zm-6.8-13.569a6.733,6.733,0,1,1,6.934,6.835l-.2,0a6.77,6.77,0,0,1-6.735-6.838Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_122"
                          data-name="Path 122"
                          d="M11105.461,6524.176a3.744,3.744,0,0,0-.395-.018h-.1c-2.715.043-5.7.062-9.379.062q-2.8,0-5.594-.009t-5.6-.01c-2.8,0-5.219,0-5.681.48s-.378,2.962-.273,5.829l.006.139c0,.132.012.237.019.321h.184c1.741-.038,3.638-.056,5.968-.056q1.928,0,3.854.01,1.9.008,3.8.01h7.268c2.738,0,5.1,0,5.56-.464s.433-2.812.4-5.531l0-.179A5.013,5.013,0,0,0,11105.461,6524.176Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_123"
                          data-name="Path 123"
                          d="M11119.126,6524.386a16.191,16.191,0,0,0-.185,3.509,2.164,2.164,0,0,0,3.061,3.04,2.618,2.618,0,0,0,3.673-3.692,2.165,2.165,0,0,0-3.062-3.041A16.045,16.045,0,0,0,11119.126,6524.386Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Mobile application design</div>
                </div>
              </Link>

              <Link to="/design/desktop-design/Marketing-design">
                <div
                  className={
                    accuratePath ===
                      "/design/desktop-design/Marketing-design" ||
                      accuratePath ===
                      "/design/marketing-design/Social-media-pages" ||
                      accuratePath ===
                      "/design/marketing-design/Social-media-ads-design" ||
                      accuratePath === "/design/marketing-design/email-design" ||
                      accuratePath ===
                      "/design/marketing-design/sales-funnel-pages"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="299.825"
                      height="301"
                      viewBox="0 0 299.825 301"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_9"
                        data-name="Group 9"
                        transform="translate(-11414.908 -6503.473)"
                      >
                        <path
                          id="Path_26"
                          data-name="Path 26"
                          d="M11650.186,6594.043q-14.653,0-29.311-.029c-9.523-.014-15.7-6.142-15.735-15.612-.05-13.574-.038-27.377-.025-40.726q.007-8.941.01-17.883c0-7.974,3.944-13.151,12.057-15.82h65.839c6.836,2.028,10.761,5.985,11.994,12.09a19.912,19.912,0,0,1,.27,3.809q.023,29.154.008,58.314c-.014,9.748-6.068,15.813-15.8,15.828Q11664.839,6594.044,11650.186,6594.043Zm16.41-5.286q6.242,0,12.484-.014c7.25-.008,10.932-3.711,10.941-11.006.024-20.236.014-40.368,0-57.392-.01-7.244-3.8-11.076-10.95-11.085q-14.424-.018-28.848-.018t-28.848.018c-7.1.009-10.847,3.744-10.847,10.8q-.025,28.986,0,57.976c0,7.094,3.654,10.7,10.862,10.705q6.173.016,12.354.014l16.344,0Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_27"
                          data-name="Path 27"
                          d="M11482.16,6785.169q-22.1,0-44.208-.019c-13.478-.008-22.531-9.078-22.531-22.57q-.025-108.624,0-217.258c0-13.508,9.042-22.6,22.5-22.633,16.154-.035,32.535-.053,48.69-.053s32.538.018,48.7.053c13.7.023,22.55,9.006,22.558,22.887q.023,20.607.01,41.211l0,22.616,7-2.907c5.323-2.213,10.421-4.332,15.527-6.437a7.772,7.772,0,0,1,2.834-.7c.684,0,2.283,0,2.283,3.965.024,30.545.024,61.514,0,92.049-.006,3.871-1.75,3.888-2.419,3.888h-.008a6.9,6.9,0,0,1-2.534-.6q-6.65-2.721-13.294-5.5-3.42-1.424-6.85-2.846l-1.345-.557-.668,1.293a6.057,6.057,0,0,0-.537,3.4c.014.215.028.427.028.637q-.015,13.819-.006,27.648c0,13.25.007,26.952-.025,40.428-.029,10.732-6.7,19.2-16.983,21.585a24.362,24.362,0,0,1-5.53.411S11495.162,6785.169,11482.16,6785.169Zm-58.429-27.389c-.866,0-2.9.322-3.085,3.31-.335,5.507,1.193,10.23,4.419,13.658,3.165,3.362,7.657,5.139,13,5.139q24.27.006,48.541.006t48.543-.006c10.562,0,17.25-6.671,17.457-17.411a4.772,4.772,0,0,0-1.04-3.579,4.827,4.827,0,0,0-3.589-1.1c-11.719.058-23.194.066-31.889.066-4.905,0-49.625-.012-49.625-.012q-20.687,0-41.378.025c-.164,0-.338-.021-.513-.038A8.361,8.361,0,0,0,11423.731,6757.78Zm11.616-229.745a8.354,8.354,0,0,0-2.017.3c-7.906,2-12.624,8.383-12.624,17.085q-.018,38.076-.009,76.154l0,44.124c0,27.039.007,55-.058,82.5a3.829,3.829,0,0,0,4.512,4.49c20.432-.039,42.294-.057,70.886-.057,11.843,0,52.573.012,52.573.012h.313a3.681,3.681,0,0,0,2.741-.883,3.949,3.949,0,0,0,.942-2.885c-.034-14.561.018-29.366.068-43.683q.028-7.608.051-15.215l.006-.238a3.192,3.192,0,0,0-1.938-3.452c-4.973-2.04-9.935-4.1-14.981-6.193l-7.921-3.282-.152,2.193c-.024.349-.05.654-.074.93-.047.549-.088,1.023-.088,1.523q0,6.6,0,13.2,0,11.6-.015,23.207c-.01,2.611-.848,3.935-2.491,3.935a6.543,6.543,0,0,1-2.647-.71c-1.69-.794-3.374-1.611-5.058-2.427-3.053-1.48-6.209-3.01-9.385-4.39-2.055-.891-2.911-2.131-3.164-4.574-.489-4.671-1.032-9.411-1.557-14-.622-5.431-1.265-11.046-1.821-16.572-.267-2.662-1.473-3.881-4.164-4.206a24.35,24.35,0,0,1-21.449-22.664c-1.037-13.35,5.849-24.237,17.543-27.735a31.961,31.961,0,0,1,9.347-1.206c2.069,0,4.107.128,5.652.239,1.584.115,3.164.173,4.7.173a52.213,52.213,0,0,0,25.2-6.164,75.433,75.433,0,0,1,8.914-3.793q.9-.336,1.786-.675a5.032,5.032,0,0,0,3.638-5.33c-.072-14.546-.07-29.335-.067-43.638q0-9.112,0-18.226a26.381,26.381,0,0,0-.257-4.081,15.562,15.562,0,0,0-11.218-13.125,12.331,12.331,0,0,0-3.413-.794c-2.851,0-2.861,2.732-2.871,5.373-.028,9.15-5.29,14.4-14.436,14.409q-15.141.01-30.281.011-18.6,0-37.219-.019a18.838,18.838,0,0,1-4.306-.373c-6.648-1.649-10.074-6.744-9.908-14.733a4.954,4.954,0,0,0-1-3.668A3.054,3.054,0,0,0,11435.348,6528.035Zm73.851,147.324a2.536,2.536,0,0,0-2,.805,3.19,3.19,0,0,0-.559,2.561c1.1,9.175,2.2,18.73,3.259,28.4a3.7,3.7,0,0,0,2.287,3.255c1.887.853,3.761,1.735,5.853,2.719l4,1.876,0-10.419c0-5.964.01-11.775-.012-17.591-.006-2.382-.061-4.8-.111-7.136l-.08-3.833-1.231-.26a21.47,21.47,0,0,0-4.532-.4c-.755,0-1.511.021-2.267.042-.724.021-1.448.041-2.174.041-.489,0-.979-.009-1.469-.036-.043,0-.127-.006-.211-.006s-.343.009-.343.009C11509.477,6675.365,11509.332,6675.359,11509.2,6675.359Zm57.827-64.009c-12.257,5.1-24.928,10.383-37.35,15.49a3.6,3.6,0,0,0-2.287,3.96c0,.127.009.255.009.384q0,5.058.006,10.12c.01,8.506.02,17.3-.077,25.948-.036,3.188,1.671,4.321,3.521,5.07,6.9,2.788,13.889,5.693,20.646,8.5l6.042,2.509c6.169,2.563,12.332,5.139,18.675,7.791l3.789,1.584v-86.758Zm-53.824,58.6c2.188,0,3.854.015,5.4.048l.157,0a3.3,3.3,0,0,0,2.465-.854,3.771,3.771,0,0,0,.84-2.836c-.037-4.211-.032-8.491-.028-12.631l0-4.216q0-2.257,0-4.514c-.008-4.138-.016-8.417.037-12.623a3.655,3.655,0,0,0-.845-2.78,3.417,3.417,0,0,0-2.521-.865l-.146,0c-1.452.026-2.905.034-4.359.034q-1.878,0-3.756-.012t-3.77-.013c-2.545,0-4.6.027-6.471.086-11.161.343-19.065,8.684-19.22,20.284-.154,11.784,7.642,20.324,18.963,20.77,2.835.112,5.663.127,8.057.127Zm-66.554-142a2.721,2.721,0,0,0-2.766,2.625c-.616,3.814-.046,6.785,1.694,8.829,1.717,2.016,4.492,3.038,8.249,3.038h65.39c7.644,0,10.235-2.632,10.271-10.43a4.152,4.152,0,0,0-.955-3.05,4.054,4.054,0,0,0-3.018-.954h-.107c-5.589.034-11.578.049-19.415.049l-36.148-.012q-10.975,0-21.951.034h0a2.392,2.392,0,0,1-.358-.044A5.727,5.727,0,0,0,11446.647,6527.949Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_28"
                          data-name="Path 28"
                          d="M11669.165,6699.135q-14.641,0-29.282-.029c-9.6-.022-15.815-6.255-15.838-15.878-.059-20.982-.059-40.139,0-58.568.029-9.565,6.287-15.754,15.94-15.769q14.569-.018,29.14-.018t29.14.018c9.826.015,15.941,6.153,15.956,16.02q.025,10.463.011,20.916v16.651q0,10.35-.011,20.7c-.021,9.653-6.212,15.9-15.768,15.926Q11683.808,6699.136,11669.165,6699.135Zm0-84.991q-14.454,0-28.907.034c-7.161.009-10.8,3.65-10.807,10.823q-.025,28.836,0,57.678c0,7.458,3.467,10.941,10.909,10.959q6.186.015,12.369.012l30.819,0q7.1,0,14.2-.009c7.518-.01,11.178-3.63,11.187-11.07.024-19.036.024-38.341,0-57.377-.009-7.295-3.708-11-11-11.021Q11683.545,6614.146,11669.164,6614.144Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_29"
                          data-name="Path 29"
                          d="M11652.235,6803.973q-15.731,0-31.466-.02c-9.265-.015-15.533-6.107-15.6-15.158-.148-19.826-.148-39.931,0-59.756.072-9,6.229-15.075,15.32-15.111q14.848-.048,29.7-.05c10.207,0,20.227.02,29.781.058,9.129.029,15.282,6.219,15.312,15.4q.04,10.272.014,20.549,0,4.518-.006,9.034l.006,9.774q.006,9.765-.006,19.526c-.029,9.539-6.162,15.714-15.623,15.729Q11665.95,6803.974,11652.235,6803.973Zm-18.613-84.8q-6.123,0-12.247.013c-7.2.018-10.846,3.623-10.846,10.715q-.025,28.988,0,57.976c0,7.057,3.754,10.792,10.854,10.8q14.424.018,28.848.018t28.84-.018c7.145-.009,10.931-3.745,10.95-10.806.022-19.239.022-38.743,0-57.973-.02-6.981-3.7-10.685-10.654-10.713q-5.851-.018-11.693-.016l-17.6.008Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_30"
                          data-name="Path 30"
                          d="M11611.486,6651.911c-.682,0-1.362-.009-2.043-.017s-1.39-.018-2.083-.018c-.649,0-1.285.007-1.921.015s-1.26.014-1.888.014c-.893,0-1.627-.015-2.311-.048-1.584-.076-2.312-.81-2.434-2.456a2.6,2.6,0,0,1,.605-1.959,2.248,2.248,0,0,1,1.644-.724c2.258-.076,4.48-.115,6.606-.115,2.222,0,4.417.043,6.522.125,1.439.057,2.218.923,2.313,2.576a2.3,2.3,0,0,1-.564,1.708,2.71,2.71,0,0,1-1.9.839C11613.28,6651.892,11612.471,6651.911,11611.486,6651.911Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_31"
                          data-name="Path 31"
                          d="M11595.925,6631.589a2.5,2.5,0,0,1-2.369-1.516,2.188,2.188,0,0,1,.208-2.65c2.373-2.54,4.808-4.977,7.232-7.243a1.95,1.95,0,0,1,1.379-.573,3.235,3.235,0,0,1,1.483.424,2.591,2.591,0,0,1,1.317,2.2C11604.9,6624.2,11597.847,6631.364,11595.925,6631.589Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_32"
                          data-name="Path 32"
                          d="M11602.649,6679.068a1.779,1.779,0,0,1-1.252-.5c-2.69-2.467-5.326-5.1-7.837-7.841a2.156,2.156,0,0,1,0-2.575,2.447,2.447,0,0,1,2.041-1.332c2,0,9.627,7.508,9.771,9.676a2.3,2.3,0,0,1-1.372,2.187A2.883,2.883,0,0,1,11602.649,6679.068Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_33"
                          data-name="Path 33"
                          d="M11633.328,6575.492c-2.041,0-2.354-2.44-2.358-3.894q-.025-8.005-.01-16.009V6542.57q-.006-8.107.01-16.22c.007-1.439.316-3.856,2.31-3.856a5.673,5.673,0,0,1,2.68.88c12.611,7.251,25.844,14.9,39.331,22.731,1.558.9,2.452,1.967,2.452,2.915s-.9,2.017-2.46,2.926c-13.967,8.1-26.841,15.527-39.354,22.7a5.488,5.488,0,0,1-2.6.847Zm3.086-7.242s23.967-13.832,30.943-17.862l2.374-1.372-2.376-1.369c-8.175-4.714-16.065-9.268-24.139-13.927l-6.8-3.927Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_34"
                          data-name="Path 34"
                          d="M11478.381,6589.432q-13.756,0-27.514-.008h-.217a11.483,11.483,0,0,1-2.386-.162,2.325,2.325,0,0,1-2.094-2.444c-.05-1.464.59-2.266,2.141-2.678a6.172,6.172,0,0,1,1.482-.122s16.345,0,24.287,0q16.641,0,33.285.013a7.418,7.418,0,0,1,2.151.248,2.288,2.288,0,0,1,1.786,2.653,2.215,2.215,0,0,1-1.934,2.3,12.711,12.711,0,0,1-2.579.19q-8.587.021-17.158.017Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_35"
                          data-name="Path 35"
                          d="M11463.716,6726.56q-7.181,0-14.362-.034c-2.772-.014-3.161-1.348-3.189-2.508a2.464,2.464,0,0,1,.613-1.854,3.625,3.625,0,0,1,2.625-.876q3.092-.031,6.189-.027l8.275.011,8.541-.009q2.817,0,5.637.016c.8.009,3.414.225,3.406,2.662-.007,2.241-2.16,2.587-3.442,2.593Q11470.863,6726.558,11463.716,6726.56Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_36"
                          data-name="Path 36"
                          d="M11669,6679.076a25.527,25.527,0,0,1-18.3-7.268,25.012,25.012,0,0,1-6.936-18.009c.127-14.681,10.6-24.934,25.475-24.934h.128a25.552,25.552,0,0,1,18.286,7.278,25.07,25.07,0,0,1,7,18c-.09,14.446-10.828,24.93-25.536,24.93Zm.109-44.972c-11.813.034-20.052,8.229-20.033,19.928.016,11.657,8.271,19.8,20.076,19.8h.093a20.368,20.368,0,0,0,14.6-5.678,19.581,19.581,0,0,0,5.476-14.256c-.06-11.654-8.339-19.792-20.134-19.792h-.073Z"
                          fill="#9cb5d4"
                        />
                        <g id="Group_8" data-name="Group 8">
                          <path
                            id="Path_37"
                            data-name="Path 37"
                            d="M11620.874,6594.514q14.659.03,29.313.03t29.308-.03c10.037-.015,16.282-6.272,16.3-16.328q.023-29.153-.008-58.314a20.328,20.328,0,0,0-.279-3.909c-1.275-6.3-5.312-10.384-12.342-12.469l-.07-.021h-65.99l-.076.025c-8.345,2.745-12.4,8.075-12.4,16.295l-.01,18.251c-.012,13.229-.024,26.91.025,40.36C11604.677,6588.176,11611.05,6594.5,11620.874,6594.514Zm-9.845-74.452c0-6.828,3.481-10.294,10.348-10.3q14.423-.018,28.847-.018t28.847.018c6.926.008,10.441,3.57,10.451,10.586.014,17.024.024,37.155,0,57.391-.01,7.061-3.425,10.5-10.442,10.506q-6.242.016-12.482.013l-16.508,0-16.344,0q-6.179,0-12.352-.013c-6.975-.008-10.364-3.346-10.364-10.206Q11611,6549.049,11611.029,6520.062Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_38"
                            data-name="Path 38"
                            d="M11583.23,6598.862a8.239,8.239,0,0,0-3.025.735c-5.106,2.1-10.2,4.224-15.528,6.437l-6.3,2.619,0-21.865q0-20.606-.011-41.213c-.008-14.183-9.058-23.363-23.056-23.386-16.157-.035-32.542-.054-48.7-.054s-32.536.019-48.69.054c-13.757.03-23,9.327-23,23.133q-.025,108.625,0,217.258c0,13.791,9.256,23.062,23.031,23.07q22.1.021,44.208.019c13,0,53.183-.011,53.183-.011a24.7,24.7,0,0,0,5.643-.424c10.522-2.435,17.341-11.1,17.371-22.07.033-13.477.029-27.179.025-40.431v-2.35q0-12.649.006-25.3c0-.2-.013-.409-.029-.669a5.554,5.554,0,0,1,.482-3.135l.456-.884,7.77,3.227q6.655,2.769,13.3,5.5a7.393,7.393,0,0,0,2.732.64c1.96,0,2.914-1.435,2.919-4.387.024-30.536.024-61.506,0-92.05C11586.014,6599.325,11584.425,6598.862,11583.23,6598.862Zm-138.854-68.209c.307-1.918,1.554-2.2,2.271-2.2a5.73,5.73,0,0,1,.889.092,2.177,2.177,0,0,0,.358.037q10.97-.042,21.95-.034l36.147.012c7.838,0,13.828-.015,19.417-.049h.105a3.618,3.618,0,0,1,2.663.809,3.7,3.7,0,0,1,.81,2.693c-.035,7.52-2.409,9.933-9.771,9.933h-65.391c-3.6,0-6.25-.963-7.868-2.862C11444.315,6537.151,11443.783,6534.316,11444.376,6530.653Zm107.726,231.813c-.2,10.437-6.7,16.921-16.957,16.921q-24.27.006-48.542.007t-48.542-.007c-5.2,0-9.564-1.722-12.631-4.982-3.129-3.325-4.61-7.92-4.283-13.285.152-2.472,1.686-2.841,2.585-2.841.256,0,.521.025.845.058a4.943,4.943,0,0,0,.506.035q20.691-.031,41.377-.025s44.721.012,49.625.012c8.714,0,20.214-.007,31.89-.066a4.391,4.391,0,0,1,3.23.955A4.336,4.336,0,0,1,11552.1,6762.466Zm.132-72.736,0,.247c-.015,5.071-.051,15.348-.051,15.348-.051,14.275-.1,29.035-.068,43.553a3.5,3.5,0,0,1-.8,2.53,3.206,3.206,0,0,1-2.386.736s-41.045-.013-52.888-.013c-28.441,0-50.3.017-70.886.058a3.352,3.352,0,0,1-4.011-3.991c.064-27.944.061-56.925.057-82.5l0-44.124q0-38.078.009-76.154c0-8.458,4.578-14.664,12.246-16.6a7.9,7.9,0,0,1,1.9-.289,2.572,2.572,0,0,1,1.919.72,4.546,4.546,0,0,1,.855,3.309c-.172,8.25,3.385,13.516,10.288,15.229a19.233,19.233,0,0,0,4.425.387q18.614.019,37.22.019,15.142,0,30.281-.011c9.463-.008,14.906-5.441,14.937-14.907.01-3.033.176-4.875,2.37-4.875a12.09,12.09,0,0,1,3.261.77,15.088,15.088,0,0,1,10.876,12.726,25.991,25.991,0,0,1,.25,4.005c0,5.194,0,18.225,0,18.225,0,13.537-.006,28.88.067,43.64a4.545,4.545,0,0,1-3.316,4.861l-1.783.674a75.662,75.662,0,0,0-8.974,3.82,51.73,51.73,0,0,1-24.963,6.1c-1.517,0-3.084-.058-4.659-.172-1.555-.112-3.606-.24-5.688-.24a32.484,32.484,0,0,0-9.49,1.226c-11.929,3.569-18.954,14.659-17.9,28.254a24.846,24.846,0,0,0,21.888,23.122c2.473.3,3.481,1.316,3.727,3.76.561,5.568,1.2,11.165,1.821,16.577l.025.222c.517,4.514,1.05,9.174,1.531,13.768.27,2.621,1.241,4.018,3.461,4.982,3.157,1.37,6.3,2.893,9.37,4.382,1.685.817,3.37,1.634,5.061,2.428a7.019,7.019,0,0,0,2.859.758c1.357,0,2.978-.769,2.991-4.433q.028-11.161.015-22.32s0-9.69,0-14.087c0-.48.04-.936.086-1.479.025-.279.052-.588.075-.939l.1-1.5,7.278,3.016c5.047,2.094,10.009,4.153,14.98,6.193A2.672,2.672,0,0,1,11552.233,6689.73Zm-30.7-44.779,0,8.986c0,4.062-.008,8.253.028,12.377a3.318,3.318,0,0,1-.694,2.481,2.821,2.821,0,0,1-2.1.707l-.152,0c-1.549-.034-3.217-.049-5.412-.049l-5.2.008c-2.387,0-5.209-.015-8.038-.126-11.033-.434-18.633-8.767-18.481-20.263.151-11.318,7.855-19.457,18.735-19.791,1.854-.059,3.905-.086,6.455-.086q1.882,0,3.766.013t3.76.012c1.456,0,2.913-.008,4.365-.034l.141,0a2.959,2.959,0,0,1,2.165.716,3.155,3.155,0,0,1,.7,2.423C11521.519,6636.549,11521.526,6640.82,11521.534,6644.951Zm.01,59.6,0,9.632-3.342-1.569c-2.071-.974-3.93-1.848-5.8-2.695a3.2,3.2,0,0,1-2-2.853c-1.05-9.6-2.146-19.16-3.258-28.4a2.748,2.748,0,0,1,.436-2.168,2.034,2.034,0,0,1,1.621-.636c.12,0,.249.006.435.018,0,0,.251-.008.325-.008s.132,0,.184.006c.5.027,1,.036,1.5.036.729,0,1.46-.02,2.189-.041.75-.021,1.5-.042,2.25-.042a20.928,20.928,0,0,1,4.43.393l.844.177.072,3.464c.051,2.326.1,4.731.11,7.1C11521.554,6692.756,11521.549,6698.547,11521.544,6704.551Zm57.954-12.595-3.095-1.294c-6.344-2.652-12.507-5.229-18.677-7.792l-6.131-2.545c-6.73-2.8-13.69-5.69-20.561-8.467-1.948-.788-3.24-1.873-3.209-4.6.1-8.756.086-17.893.076-25.954q-.006-5.061,0-10.119c0-.135,0-.269-.01-.4a3.1,3.1,0,0,1,1.978-3.481c12.4-5.1,25.043-10.364,37.351-15.49l12.281-5.113Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_39"
                            data-name="Path 39"
                            d="M11714.721,6624.91c-.015-10.174-6.32-16.5-16.455-16.519q-14.571-.018-29.141-.017t-29.141.017c-9.957.015-16.409,6.4-16.438,16.268-.06,18.429-.06,37.588,0,58.57.022,9.926,6.436,16.355,16.337,16.377q14.64.03,29.282.029t29.289-.029c9.86-.022,16.244-6.47,16.267-16.425q.023-10.352.011-20.7v-16.651Q11714.734,6635.369,11714.721,6624.91Zm-6.287,57.658c-.009,7.2-3.4,10.561-10.688,10.57q-7.1.012-14.2.01l-30.819,0q-6.183,0-12.368-.012c-7.2-.018-10.41-3.243-10.41-10.46q-.023-28.833,0-57.676c.009-6.939,3.38-10.316,10.308-10.324q14.452-.037,28.906-.034,14.385,0,28.774.025c7.054.018,10.486,3.46,10.5,10.523C11708.458,6644.228,11708.458,6663.532,11708.434,6682.568Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_40"
                            data-name="Path 40"
                            d="M11695.783,6729.339c-.03-9.482-6.384-15.873-15.81-15.9-9.556-.038-19.575-.058-29.783-.058q-14.854,0-29.7.05c-9.386.037-15.743,6.309-15.817,15.607-.147,19.828-.147,39.935,0,59.763.067,9.349,6.537,15.64,16.1,15.655q15.732.019,31.466.02,13.718,0,27.434-.02c9.764-.015,16.092-6.385,16.122-16.228q.023-9.761.006-19.527l-.006-9.774.006-9.033Q11695.807,6739.615,11695.783,6729.339Zm-6.262,58.536c-.019,6.83-3.535,10.3-10.451,10.307q-14.417.016-28.839.018t-28.847-.018c-6.871-.009-10.355-3.474-10.355-10.3q-.025-28.987,0-57.976c0-6.856,3.385-10.2,10.347-10.215q6.123-.015,12.246-.013l16.451.006,17.6-.009q5.843,0,11.691.016c6.721.027,10.138,3.464,10.156,10.214C11689.544,6749.133,11689.544,6768.637,11689.521,6787.875Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_41"
                            data-name="Path 41"
                            d="M11607.663,6646.1c-2.127,0-4.355.038-6.623.114a2.738,2.738,0,0,0-2,.89,3.1,3.1,0,0,0-.732,2.33c.142,1.9,1.065,2.83,2.909,2.919.69.033,1.433.048,2.334.048.631,0,1.263-.007,1.893-.014l.11,0c.6-.007,1.2-.014,1.8-.014.692,0,1.384.009,2.077.019s1.366.017,2.049.017c1,0,1.813-.019,2.572-.061a3.2,3.2,0,0,0,2.248-1,2.781,2.781,0,0,0,.691-2.07c-.108-1.9-1.1-2.98-2.792-3.046C11612.091,6646.146,11609.89,6646.1,11607.663,6646.1Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_42"
                            data-name="Path 42"
                            d="M11595.915,6632.089h.035l.034,0c2.134-.25,9.377-7.566,9.687-9.785l.01-.068-.01-.068a3.149,3.149,0,0,0-1.577-2.575,3.73,3.73,0,0,0-1.719-.483,2.457,2.457,0,0,0-1.72.708c-2.435,2.273-4.876,4.718-7.257,7.267a2.648,2.648,0,0,0-.292,3.211A3,3,0,0,0,11595.915,6632.089Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_43"
                            data-name="Path 43"
                            d="M11605.868,6676.461c-.157-2.365-8.026-10.139-10.288-10.142a2.924,2.924,0,0,0-2.456,1.583,2.573,2.573,0,0,0,.068,3.162c2.523,2.75,5.17,5.4,7.866,7.872a2.293,2.293,0,0,0,1.59.632,3.389,3.389,0,0,0,1.588-.447A2.827,2.827,0,0,0,11605.868,6676.461Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_44"
                            data-name="Path 44"
                            d="M11633.329,6575.992a5.978,5.978,0,0,0,2.848-.913c12.453-7.138,25.326-14.563,39.357-22.7,1.745-1.016,2.707-2.208,2.707-3.358s-.959-2.336-2.7-3.348c-13.417-7.791-26.65-15.439-39.333-22.732a6.161,6.161,0,0,0-2.929-.946c-1.772,0-2.8,1.587-2.81,4.355q-.025,8.115-.01,16.221v13.018q-.006,8.005.01,16.011C11630.48,6574.39,11631.521,6575.991,11633.329,6575.992Zm3.585-45.333,31.817,18.358-31.817,18.368Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_45"
                            data-name="Path 45"
                            d="M11448.159,6589.751a11.866,11.866,0,0,0,2.49.173h.218q13.756.012,27.514.008h11.252q8.575,0,17.157-.017a13.113,13.113,0,0,0,2.691-.2,2.709,2.709,0,0,0,2.321-2.759,2.786,2.786,0,0,0-2.14-3.158,7.894,7.894,0,0,0-2.3-.269q-16.642-.013-33.285-.013l-24.287,0a6.5,6.5,0,0,0-1.609.138,2.9,2.9,0,0,0-2.513,3.178A2.823,2.823,0,0,0,11448.159,6589.751Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_46"
                            data-name="Path 46"
                            d="M11478.048,6720.779q-2.821-.018-5.641-.016l-8.539.009-8.276-.011q-3.1,0-6.2.027a4.1,4.1,0,0,0-2.98,1.03,2.946,2.946,0,0,0-.752,2.212c.049,2,1.255,2.984,3.687,3q7.185.036,14.365.034,7.148,0,14.3-.026c2.5-.013,3.934-1.14,3.939-3.091C11481.959,6721.641,11479.94,6720.8,11478.048,6720.779Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_47"
                            data-name="Path 47"
                            d="M11669.37,6628.365h-.13c-15.164,0-25.844,10.457-25.975,25.429a25.5,25.5,0,0,0,7.08,18.365,26.021,26.021,0,0,0,18.654,7.418h.114c15,0,25.945-10.694,26.036-25.427a25.561,25.561,0,0,0-7.142-18.359A26.049,26.049,0,0,0,11669.37,6628.365Zm14.117,39.434a19.943,19.943,0,0,1-14.335,5.531c-11.511,0-19.561-7.936-19.576-19.3-.018-11.4,8.016-19.394,19.533-19.427v-.5l.074.5c11.5,0,19.576,7.934,19.634,19.295A19.093,19.093,0,0,1,11683.487,6667.8Z"
                            fill="#9cb5d4"
                          />
                          <path
                            id="Path_48"
                            data-name="Path 48"
                            d="M11669.449,6739.139c-1.549-.913-3.155-1.806-4.753-2.694-2.93-1.627-5.958-3.309-8.806-5.24a8.333,8.333,0,0,0-4.462-1.788,2.445,2.445,0,0,0-1.871.763c-.937.985-1.388,2.875-1.268,5.323.24,5.016.2,10.112.151,15.072-.027,3.028-.056,6.158-.017,9.227a3.69,3.69,0,0,1-.676,2.714,2.206,2.206,0,0,1-1.639.6,7.572,7.572,0,0,1-1.528-.2,15.749,15.749,0,0,0-3.174-.333,12.432,12.432,0,0,0-12.577,10.457,12.989,12.989,0,0,0,1.989,9.874,13.447,13.447,0,0,0,8.938,5.35,13.891,13.891,0,0,0,2.285.193c7.19,0,12.657-5.653,12.715-13.149.065-8.026.052-15.915.037-24.268v-.251q-.01-5.41-.013-10.948v-1.877l4.7,2.726c2.249,1.309,4.576,2.662,6.824,3.919a5.16,5.16,0,0,0,2.453.729,2.789,2.789,0,0,0,2.526-1.522C11672.263,6742.108,11671.593,6740.4,11669.449,6739.139Zm-27.562,42.883h-.146a6.359,6.359,0,0,1-6.7-6.43,6.459,6.459,0,0,1,1.748-4.73,6.788,6.788,0,0,1,4.846-1.942l.155,0a6.552,6.552,0,1,1,.1,13.1Z"
                            fill="#9cb5d4"
                          />
                        </g>
                        <path
                          id="Path_49"
                          data-name="Path 49"
                          d="M11642.044,6787.961a13.411,13.411,0,0,1-2.2-.186,12.94,12.94,0,0,1-8.61-5.145,12.491,12.491,0,0,1-1.907-9.5,11.945,11.945,0,0,1,12.085-10.046,15.165,15.165,0,0,1,3.073.323,8.037,8.037,0,0,0,1.63.206,2.686,2.686,0,0,0,1.994-.749,4.082,4.082,0,0,0,.819-3.072c-.039-3.065-.011-6.2.017-9.223.045-4.944.09-10.055-.152-15.093-.111-2.277.3-4.083,1.131-4.954a1.948,1.948,0,0,1,1.509-.608,7.871,7.871,0,0,1,4.182,1.7c2.854,1.937,5.9,3.628,8.843,5.264,1.564.87,3.183,1.769,4.742,2.688,1.1.649,2.781,2.03,1.658,4a2.284,2.284,0,0,1-2.092,1.269h0a4.673,4.673,0,0,1-2.209-.665c-2.221-1.242-4.453-2.54-6.815-3.915-.991-.577-5.454-3.161-5.454-3.161v2.744q0,5.545.013,10.949c.015,8.439.03,16.41-.037,24.514C11654.2,6782.522,11648.952,6787.961,11642.044,6787.961Zm-.416-19.54a7.288,7.288,0,0,0-5.2,2.094,6.951,6.951,0,0,0-1.889,5.086,6.839,6.839,0,0,0,7.2,6.923l.15,0a6.756,6.756,0,0,0,7.041-7.188c-.061-4.137-2.932-6.914-7.147-6.914Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Marketing Design</div>
                </div>
              </Link>
            </Slider>

            {accuratePath === "/design" ||
              accuratePath === "/design/website-design" ||
              accuratePath === "/web-design" ||
              accuratePath === "/design/web-design/UI-UX" ||
              accuratePath === "/ux-ui-designing" ||
              accuratePath === "/design/web-design/logo" ||
              accuratePath === "/design/web-design/infographics" ||
              accuratePath === "/design/web-design/landing-pages" ||
              accuratePath === "/design/web-design/mockups" ||
              accuratePath === "/design/web-design/prototype" ||
              accuratePath === "/design/web-design/splash-pages" ||
              accuratePath === "/design/web-design/banner-design" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/design/website-design">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Website Design
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/web-design/UI-UX">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          UI/UX
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/web-design/logo">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Logo
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/web-design/infographics">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Infographics
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/web-design/landing-pages">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Landing pages
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/web-design/mockups">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Mockups
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/web-design/prototype">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Prototype
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/web-design/splash-pages">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Splash Pages
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/web-design/banner-design">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Banner Design
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          {/* <MetaTags>
                            <meta
                              id="meta-description"
                              name="description"
                              content="Boost your online presence with our website design services. Our expert team creates beautiful and user-friendly websites tailored to your brand needs."
                            />
                          </MetaTags> */}
                         

                          {path === '/design' && (
                             <Helmet>
                             <title>Graphic Design & Professional Website Designers Company</title>
                             <meta
                               name="keyword"
                               content="graphic design website, professional website designer, professional web designers, website design company"
                             />
                             <meta
                               name="description"
                               content="Kindlebit is a website design company offering graphic design website services and professional web designers. Expand and enhance your online presence with us."
                             />
                           </Helmet>
                          )}
                          {path === '/design/website-design' && (
                           <Helmet>
                           <title>Expert Website Design Services and UI & UX Design for your website</title>
                           <meta
                             name="keyword"
                             content="website design services, UI and ux design"
                           />
                           <meta
                             name="description"
                             content="Elevate your brand with professional website design services. Get stunning visuals and seamless UI and UX design for better user engagement. Contact Kindlebit Now!"
                           />
                         </Helmet>
                          )}


                          <div className="ipc">
                            <div className="sap-md-heading">Website Design</div>
                            <div className="text-para">
                              The art of organizing matter on a website is known
                              as web design. It includes user experience of the
                              website development which encompasses appearance,
                              layout, content of the website, and color
                              philosophy as per how the brand wants to portray
                              itself. Any website design includes elements like
                              UI and UX, logos, Infographics, Landing Pages,
                              Mockups, Prototypes, Splash Pages, and Banner
                              Design among other things.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>sketch</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/sketch.png"
                                      alt="sketch"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">

                          <div className="ipc">
                            <div className="sap-md-heading">UI/UX</div>
                            <div className="text-para">
                              <p>
                                UX or User Experience design includes how the
                                user reacts while navigating the website. For
                                any website to provide a good experience to the
                                users; a UX designer does comprehensive research
                                regarding what the users are looking for while
                                navigating similar websites coupled with testing
                                of the various elements and how people react to
                                certain tasks at hand; and hence the design is
                                changed as per the feedback by users. UX
                                designers also help create a conducive content
                                strategy which is in line with the user
                                experience brands want users to have when they
                                visit the content of a website.
                              </p>
                              <p>
                                UI or User Interface design incorporates how a
                                particular webpage looks. This plays a
                                significant role in how page content looks, what
                                kind of typography is used, and whether the
                                content shall contain animations or not all the
                                other design choices are made depending upon the
                                niche as well as the needs of the organization.
                              </p>
                              <p>
                                As a general rule of thumb, in the case of
                                websites, websites must follow a responsive and
                                adaptive design choice thus adapting as per the
                                screen size of the device in which the content
                                is being viewed.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>sketch</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/sketch.png"
                                      alt="sketch"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Logo</div>
                            <div className="text-para">
                              <p>
                                Logo plays an essential role for any website,
                                app, or anything as it gives a unique branding
                                opportunity to the brands. Also, a logo plays an
                                important role in setting up a brand for success
                                as a great logo gives a unique talking point for
                                the brand also logo is the most recognizable
                                thing for any brand; and hence careful
                                consideration needs to be made before selecting
                                what kind of logo a brand wants to cause, it is
                                bound to stay with them at least for a few years
                                and some until they are operating.
                              </p>
                              <p>
                                A logo for a website is usually a flattering
                                design element with muted colors which has
                                become the norm for big brands rather than just
                                going for typography with gray colors or no
                                colors at all. This gives them the ability to
                                easily use their logo on everything.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Infographics</div>
                            <div className="text-para">
                              <p>
                                Infographics are known to give a lot of
                                information in a byte-sized format with graphics
                                attached to them thus making it easier for
                                people to remember data in it. Infographics are
                                known to give a boost to SEO efforts. A good
                                Infographic often leads to many backlinks as
                                well as mentions from various brands or news
                                aggregators.
                              </p>
                              <p>
                                They are also used in sharing across various
                                social media platforms and thus form an
                                important part of the social media strategy as
                                well.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Landing pages</div>
                            <div className="text-para">
                              <p>
                                Landing pages are standalone web pages created
                                solely for marketing or advertising a product or
                                service. They have a specific style of content
                                with great graphics and content copy that leads
                                to click-through.
                              </p>
                              <p>
                                The language must write; the UI, and UX of the
                                page; are in line with the goals that the
                                marketer has as well as the content of the
                                landing page is clear and precise and asks the
                                visitor directly what it wants the user to do as
                                the user lands on the page else the user might
                                get confused; and hence all the efforts made in
                                creating the landing page would go in vain.
                              </p>
                              <p>
                                Creating great landing pages is easier said than
                                done and often requires the expertise of
                                marketers, and designers working together to
                                create great landing pages.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>sketch</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/sketch.png"
                                      alt="sketch"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Mockups</div>
                            <div className="text-para">
                              <p>
                                A website mockup gives a clear idea of how the
                                business wants the website to look before the
                                developers start working on the aforementioned
                                project.
                              </p>
                              <p>
                                Mockups are used to create all the necessary
                                elements like the color scheme, typography,
                                compliance with web accessibility features, etc.
                                Client Feedback is taken on all these elements.
                                Thus, it helps the various stakeholders get a
                                better vision of what they want from the project
                                and hence they can work accordingly.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>sketch</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/sketch.png"
                                      alt="sketch"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Prototype</div>
                            <div className="text-para">
                              <p>
                                A prototype for a website is a product that is
                                created to test concepts and adjustments before
                                becoming the final product. It allows for
                                testing different ideas' viability and
                                validating the overall user-experience (UX)
                                approach by mocking up every feature and
                                interaction in the prototype as they would
                                appear in the final product.
                              </p>
                              <p>
                                It also evaluates how users would navigate from
                                one page to another and test website usability
                                and functionality.
                              </p>
                              <p>
                                A prototype for the website would typically be a
                                small-scale website with limited functionality
                                however containing all the basic features so
                                that the businesses get a better idea of what to
                                expect once the final website is released. This
                                allows businesses to recommend changes that they
                                want and also gives them the cushion to see the
                                viability of their idea.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Splash pages</div>
                            <div className="text-para">
                              <p>
                                A splash page is a page that appears before any
                                other page on your website. Depending upon the
                                industry or market your company serves, a splash
                                page may be used to advertise a new deal,
                                display a disclaimer, or provide a warning.
                              </p>
                              <p>
                                Instead of being a standalone page, a splash
                                page is more of a big window that is housed on
                                the homepage of the website. The splash page's
                                objective is to give the visitor useful
                                information.
                              </p>
                              <p>
                                A standard splash page has a background picture,
                                not much text, and most importantly a link that
                                directs the user to the main page of the
                                website.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>sketch</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/sketch.png"
                                      alt="sketch"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Banner design</div>
                            <div className="text-para">
                              <p>
                                Website banners are excellent tools to be
                                included in any marketing effort. They are used
                                in third-party websites and are used to target
                                the audience of their niche and have been known
                                to keep low customer acquisition costs along
                                with high return on investment; and hence are
                                preferred by marketers to market their products.
                              </p>
                              <p>
                                A good banner should include a catchy headline,
                                a brief explanation of the product or service,
                                an eye-catching image, a simple yet effective
                                call to action, and brand identifiers like
                                website URL, logo, etc.; thus, creating a great
                                banner requires proper synergy between the
                                marketers as well as designers, so that the
                                banner which is created works exactly as it was
                                intended.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>sketch</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/sketch.png"
                                      alt="sketch"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/design/desktop-design" ||
              accuratePath === "/design/desktop-design/logo" ||
              accuratePath === "/design/desktop-design/mockups" ||
              accuratePath === "/design/desktop-design/prototype" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="desktop-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/design/desktop-design">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Desktop Design
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/desktop-design/logo">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          {" "}
                          Logo
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/desktop-design/mockups">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Mockups
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/desktop-design/prototype">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Prototype
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          {/* <MetaTags>
                            <meta
                              id="meta-description"
                              name="description"
                              content="Elevate user experience with desktop design services. Our experts create sleek desktop designs tailored to your needs. Contact us today to learn more!."
                            />
                          </MetaTags> */}
                          <Helmet>
                            <title>Desktop Application Design & UI Design for PC | Kindlebit</title>
                            <meta
                              name="keyword"
                              content="desktop application design, design app for pc, desktop app ui design, desktop ui design"
                            />
                            <meta
                              name="description"
                              content="Expert desktop application design services, desktop UI design, design app for PC, and professional desktop app UI design for seamless user experience."
                            />
                          </Helmet>


                          <div className="ipc">
                            <div className="sap-md-heading">Desktop Design</div>
                            <div className="text-para">
                              The popularity of web apps and mobile apps may
                              have questioned businesses on whether they would
                              benefit from having a desktop application.
                              However, time and again it has been proven that
                              desktop applications have a certain edge over
                              their web and mobile counterparts. Desktop apps
                              need to take care of certain design elements which
                              include UI/UX, Logo, Mockups, and Prototype.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>sketch</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/sketch.png"
                                      alt="sketch"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Logo</div>
                            <div className="text-para">
                              A logo for a desktop app should be simple yet
                              elegant and should reflect upon the design
                              philosophy of the app and what purpose the app is
                              solving that should also be taken into account
                              while creating a logo for the app.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Mockups</div>
                            <div className="text-para">
                              A desktop app mockup contains static images that
                              give a glimpse of how the desktop app would look.
                              It contains elements like the color scheme,
                              typography, menu placement, etc; so that client
                              feedback is taken into account while further
                              decision is taken for the development of the app.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>sketch</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/sketch.png"
                                      alt="sketch"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Prototype</div>
                            <div className="text-para">
                              A prototype for a desktop app contains all the
                              basic functionalities of a fully developed app
                              thus various stakeholders can realize the
                              feasibility of the project and hence time and
                              money are saved for all the stakeholders.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/design/mobile-application-design" ||
              accuratePath === "/design/Mobile-application-design/logo" ||
              accuratePath === "/design/Mobile-application-design/infographics" ||
              accuratePath === "/design/Mobile-application-design/mockups" ||
              accuratePath === "/design/Mobile-application-design/prototype" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="mobile-app-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/design/Mobile-application-design">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Mobile Application Design
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/Mobile-application-design/logo">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Logo
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/Mobile-application-design/infographics">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Infographics
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/Mobile-application-design/mockups">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Mockups
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/Mobile-application-design/prototype">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Prototype
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        {/* <MetaTags>
                            <meta
                              id="meta-description"
                              name="description"
                              content="Get the best mobile experience with our mobile app design services. We are experts in creating striking and user-friendly designs. Contact us now!"
                            />
                          </MetaTags> */}
                        <Helmet>
                          <title>Best Mobile App Design Services with Smart UI and UX Design</title>
                          <meta
                            name="keyword"
                            content="mobile app design services, UI and UX design"
                          />
                          <meta
                            name="description"
                            content="Create engaging mobile apps with expert UI and UX design. Our mobile app design services blend beauty and functionality for top user experiences. Visit us for more!"
                          />
                        </Helmet>

                        <div className="inner-page-con">

                          <div className="ipc">
                            <div className="sap-md-heading">
                              Mobile Application Design
                            </div>
                            <div className="text-para">
                              Mobile applications have taken the front seat for
                              development both by developers and organizations
                              simply because of the amount of time people use
                              their Smartphones. Thus, having a great mobile app
                              is a must for any business to survive. In the case
                              of mobile applications, elements such as UI/UX,
                              Logo, Infographics, Mockups, Prototype and Banner
                              design play an important part in developing the
                              applications.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>sketch</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/sketch.png"
                                      alt="sketch"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Logo</div>
                            <div className="text-para">
                              <p>
                                Mobile app's logo or icon is the most
                                recognizable part of any app; and hence careful
                                consideration is taken into account before any
                                logo is decided because a logo provides a unique
                                power to every app available on the marketplace.
                                More often than not once a logo is decided for
                                any app; it tends to remain the same throughout
                                the life cycle of the application.
                              </p>
                              <p>
                                Mobile app logos can vary as per the niche of
                                the industry they operate in; however, they are
                                designed to look flatter and generally have
                                self-explanatory logos, thus making it easier
                                for people to recognize the app after
                                installing.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Infographics</div>
                            <div className="text-para">
                              <p>
                                Infographis are an important part of the
                                marketing strategy for any website that has been
                                established by SEO experts; however, the amount
                                of shares that Infographic get has meant that
                                they are now being used by mobile developers as
                                well.
                              </p>
                              <p>
                                Mobile app developers use Infographics to
                                explain key features of the app directly and
                                they help them to sell their apps as white
                                labels, to market their app as well as to
                                increase downloads of their app across the
                                mobile marketplace as a good Infographic leads
                                to a lot of shares and hence leads to downloads
                                by people.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Mockups</div>
                            <div className="text-para">
                              A mobile app mockup contains static images that
                              look at how the mobile app would appear during
                              post initial discussion with the client. It
                              contains elements like the color scheme,
                              typography, menu placement, etc; so that client
                              feedback is taken into account while the further
                              decision is taken on how the mobile application
                              should look.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>sketch</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/sketch.png"
                                      alt="sketch"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Prototype</div>
                            <div className="text-para">
                              A prototype of a mobile application is a basic
                              application which has the basic functionality;
                              however, may not contain the full-color
                              scheme-based menus and typography as per
                              discussion however contains all the basic Ui and
                              UX elements thus providing clients as well as
                              developers with the opportunity to make the
                              necessary changes so that the app becomes success
                              post-launch.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>adobe XD</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_XD.png"
                                      alt="adobe XD"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>figma</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/figma.png"
                                      alt="figma"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/design/desktop-design/Marketing-design" ||
              accuratePath === "/design/marketing-design/Social-media-pages" ||
              accuratePath ===
              "/design/marketing-design/Social-media-ads-design" ||
              accuratePath === "/design/marketing-design/email-design" ||
              accuratePath === "/design/marketing-design/sales-funnel-pages" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="marketing-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/design/marketing-design">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Marketing Design
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/marketing-design/Social-media-pages">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Social Media Pages
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/marketing-design/Social-media-ads-design">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Social Media Ads Design
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/marketing-design/email-design">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Email Design
                        </div>
                      </Link>
                    </Tab>
                    <Tab>
                      <Link to="/design/marketing-design/sales-funnel-pages">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Sales Funnel Pages
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                            <meta
                              id="meta-description"
                              name="description"
                              content="Boost engagement and conversions with Kindlebit now. We specialize in crafting visually appealing designs to polish your marketing. Call us today!"
                            />
                          </MetaTags> */}
                        <Helmet>
                          <title>Web Design, SEO Services & Branding Marketing Company</title>
                          <meta
                            name="keyword"
                            content="website design and marketing, web design and marketing, branding marketing company, website design seo services"
                          />
                          <meta
                            name="description"
                            content="Discover professional website design and marketing solutions and website design SEO services. Partner with us to enhance your online presence and drive results."
                          />
                        </Helmet>

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Marketing Design
                            </div>
                            <div className="text-para">
                              <p>
                                Digital marketing has played a pivotal role in
                                the last decade in how advertisers spend money
                                to attract the audience which is right for their
                                business. It provides such granular control to
                                attract the people who would be interested in
                                your business, something which wasn’t possible
                                with traditional media.
                              </p>
                              <p>
                                For any marketing campaign to work it requires a
                                strong design philosophy that resonates with the
                                audience as well as is in line with the
                                company’s goals.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Social Media Pages
                            </div>
                            <div className="text-para">
                              <p>
                                Social media has changed the way people
                                communicate with one another as well as for
                                businesses in how they interact with their
                                customers as well as acquire new customers. With
                                the rise of the number of users, businesses
                                across social media platforms it has become
                                notoriously difficult for them to create
                                engaging content which works consistently;
                                hence, they sometimes work with social media
                                management companies on the outside or sometimes
                                hire in-house talent that helps them create
                                content which resonates with their audience.
                              </p>
                              <p>
                                Content across social media should follow a
                                certain kind of design philosophy which may not
                                be possible without a designer having a closer
                                look through the entire process. A designer also
                                helps set the color palette, and what kind of
                                graphics shall be used along with the logo of
                                the business. Thus, designers give a boost to
                                the social media pages of businesses.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Social Media Ads Design
                            </div>
                            <div className="text-para">
                              <p>
                                For businesses, a lot of leads and sales they
                                generate are through the ads they put on social
                                media ads. Social media apps provide a lot of
                                ways in which advertisers can leverage to put
                                content that could lead to potential leads and
                                conversions.
                              </p>
                              <p>
                                However, this is easier said than done as a good
                                ad copy is essential as a lot of advertisers are
                                competing for the ad space. A great copy is not
                                only a delight for the customers but also helps
                                keep the cost of advertising down as good ads
                                are rewarded more easily, and often lead to
                                higher click-through rates; thus, leading to
                                decreased customer acquisition cost (CAC) and
                                higher return on investment (ROI).
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Email Design</div>
                            <div className="text-para">
                              <p>
                                Email is still an important part of every
                                business’s marketing strategy because email has
                                a higher ROI as compared to some other marketing
                                channels. However, designing a great email is
                                easier said than done.
                              </p>
                              <div className="sap-sm-heading">
                                A great email requires:
                              </div>
                              <div className="text-para">
                                <ul>
                                  <li>Engaging graphics</li>
                                  <li>A great copy</li>
                                  <li>A clear call to action</li>
                                </ul>
                                <p>
                                  Thus, requiring harmony between marketers and
                                  designers to create the perfect email to be
                                  sent to their current and prospective
                                  customers or clients.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Sales Funnel Pages
                            </div>
                            <div className="text-para">
                              <p>
                                Sales funnels are an important arsenal in any
                                marketer's quiver. They help move the target
                                audience from different stages to conversion and
                                provide great insights to marketers about their
                                audience; hence, every website owner should use
                                at least one form of click funnel or the other
                                to better understand their audience.
                              </p>
                              <p>
                                The sales funnel has 6 stages: awareness,
                                interest, consideration, intent, evaluation, and
                                purchase.
                              </p>
                              <p>
                                All these stages play a different role in
                                nudging the customer to make a purchase or act
                                as a lead and hence marketers work with
                                designers to carefully craft sales funnel pages
                                that drive customers while working on these
                                pages continuously to optimize them for further
                                conversion.
                              </p>
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Photoshop</Tooltip>}
                                  >
                                    <img
                                      src="/assets/images/software-icons/ps.png"
                                      alt="Photoshop"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Adobe illustrator</Tooltip>
                                    }
                                  >
                                    <img
                                      src="/assets/images/software-icons/Adobe_Illustrator.png"
                                      alt="Adobe illustrator"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
          </div>
        </section>
      </main>

      {/* Contact modal */}
      {commonModal && (
        <ContactModal
          commonModal={commonModal}
          setCommonModal={setCommonModal}
        />
      )}
    </>
  );
}
export default Design;
